(ns bp-libs.design-system.components.icons
  "Namespace used for icons used throughout apps")

(defn laptop-mac
  [{:keys [width height]}]
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width (or width 72)
    :height (or height 72)
    :view-box "0 0 72 72",
    :fill "none"}
   [:g
    [:path
     {:d
      "M6.828 58.358c-1.258 0-2.35-.451-3.274-1.356-.925-.904-1.387-1.985-1.387-3.244h11.06c-1.423 0-2.632-.498-3.627-1.494-.996-.996-1.494-2.205-1.494-3.627V16.166c0-1.421.498-2.63 1.494-3.626.995-.996 2.202-1.494 3.62-1.494h45.56c1.418 0 2.625.498 3.62 1.494.996.996 1.494 2.204 1.494 3.626v32.472c0 1.422-.498 2.631-1.493 3.627-.996.996-2.205 1.494-3.627 1.494h11.06c0 1.261-.463 2.343-1.388 3.246-.924.903-2.016 1.355-3.274 1.355H6.828Zm29.164-2.007c.652 0 1.2-.22 1.644-.658.444-.44.666-.985.666-1.636 0-.651-.22-1.2-.658-1.644-.44-.444-.985-.666-1.636-.666-.652 0-1.2.22-1.644.659-.444.439-.666.984-.666 1.635 0 .652.22 1.2.659 1.644.439.444.984.666 1.635.666Zm-22.766-6.79h45.548c.23 0 .442-.096.635-.289.192-.192.288-.404.288-.634V16.165c0-.23-.096-.442-.288-.634-.193-.193-.404-.289-.635-.289H13.226c-.23 0-.442.096-.635.289-.192.192-.288.404-.288.634v32.472c0 .231.096.443.288.635.193.193.404.289.635.289Z",
      :fill "currentColor"}]]])

(defn- home-default []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 25 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M11.4774 1.83611C11.8197 1.74343 12.1805 1.74343 12.5228 1.83611C12.9202 1.9437 13.2548 2.20636 13.5218 2.41599C13.5473 2.43601 13.5721 2.45554 13.5964 2.4744L20.3787 7.74953C20.4048 7.76983 20.4307 7.78994 20.4564 7.80989C20.833 8.10217 21.1648 8.35967 21.4121 8.69396C21.6291 8.98735 21.7907 9.31786 21.8891 9.66926C22.0012 10.0697 22.0007 10.4897 22.0002 10.9664C22.0002 10.999 22.0001 11.0317 22.0001 11.0648V18.3383C22.0002 18.8654 22.0002 19.3202 21.9696 19.6948C21.9373 20.0901 21.866 20.4833 21.6732 20.8617C21.3855 21.4262 20.9266 21.8851 20.3621 22.1728C19.9837 22.3656 19.5905 22.4369 19.1952 22.4692C18.8206 22.4998 18.3658 22.4998 17.8387 22.4997H6.16157C5.63443 22.4998 5.17968 22.4998 4.80511 22.4692C4.40977 22.4369 4.01655 22.3656 3.63817 22.1728C3.07368 21.8851 2.61474 21.4262 2.32712 20.8617C2.13433 20.4833 2.06301 20.0901 2.03071 19.6948C2.00011 19.3202 2.00012 18.8654 2.00014 18.3383L2.00014 11.0648C2.00014 11.0317 2.0001 10.999 2.00007 10.9664C1.99955 10.4897 1.9991 10.0697 2.11118 9.66926C2.20954 9.31785 2.37119 8.98735 2.58818 8.69396C2.83544 8.35966 3.16725 8.10216 3.54389 7.80987C3.56958 7.78993 3.59549 7.76983 3.62159 7.74953L10.4039 2.4744C10.4282 2.45554 10.453 2.436 10.4785 2.41599C10.7455 2.20636 11.0801 1.9437 11.4774 1.83611ZM11.9928 3.78128C11.9177 3.83149 11.8187 3.90773 11.6318 4.05311L4.84947 9.32823C4.3514 9.71562 4.25864 9.79877 4.19615 9.88326C4.12382 9.98105 4.06994 10.0912 4.03715 10.2084C4.00883 10.3096 4.00014 10.4338 4.00014 11.0648V18.2997C4.00014 18.8763 4.00092 19.2486 4.02407 19.5319C4.04626 19.8036 4.08394 19.9043 4.10913 19.9537C4.20501 20.1419 4.35799 20.2949 4.54615 20.3907C4.59559 20.4159 4.69631 20.4536 4.96798 20.4758C5.25131 20.499 5.62359 20.4997 6.20014 20.4997H17.8001C18.3767 20.4997 18.749 20.499 19.0323 20.4758C19.304 20.4536 19.4047 20.4159 19.4541 20.3907C19.6423 20.2949 19.7953 20.1419 19.8911 19.9537C19.9163 19.9043 19.954 19.8036 19.9762 19.5319C19.9994 19.2486 20.0001 18.8763 20.0001 18.2997V11.0648C20.0001 10.4338 19.9915 10.3096 19.9631 10.2084C19.9303 10.0912 19.8765 9.98105 19.8041 9.88326C19.7416 9.79877 19.6489 9.71562 19.1508 9.32823L12.3685 4.05311C12.1816 3.90773 12.0826 3.83149 12.0074 3.78128C12.0049 3.77958 12.0025 3.77797 12.0001 3.77645C11.9978 3.77797 11.9954 3.77958 11.9928 3.78128ZM12.0001 11.4997C10.8956 11.4997 10.0001 12.3952 10.0001 13.4997C10.0001 14.6043 10.8956 15.4997 12.0001 15.4997C13.1047 15.4997 14.0001 14.6043 14.0001 13.4997C14.0001 12.3952 13.1047 11.4997 12.0001 11.4997ZM8.00014 13.4997C8.00014 11.2906 9.791 9.49974 12.0001 9.49974C14.2093 9.49974 16.0001 11.2906 16.0001 13.4997C16.0001 15.7089 14.2093 17.4997 12.0001 17.4997C9.791 17.4997 8.00014 15.7089 8.00014 13.4997Z",
     :fill      "currentColor"}]])

(defn- home-a [{:keys [fill inner-stroke]
                :or   {fill "none"
                       inner-stroke "currentColor"}}]
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 25 25",
    :fill fill}
   [:path
    {:d
     "M12.5 17.99V14.99M9.52 2.84001L4.13 7.04001C3.23 7.74001 2.5 9.23001 2.5 10.36V17.77C2.5 20.09 4.39 21.99 6.71 21.99H18.29C20.61 21.99 22.5 20.09 22.5 17.78V10.5C22.5 9.29001 21.69 7.74001 20.7 7.05001L14.52 2.72001C13.12 1.74001 10.87 1.79001 9.52 2.84001Z",
     :stroke inner-stroke,
     :stroke-opacity 1,
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn- home-variants []
  {:default home-default
   :a       home-a})

(defn home [{:keys [variant]
             :or   {variant :default}}]
  (get (home-variants) variant))

(defn diamond []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M7.34729 2.49973C7.35742 2.49981 7.36644 2.49988 7.37424 2.49988H9.97619C9.99162 2.49951 10.0071 2.49951 10.0226 2.49988H13.9765C13.992 2.49951 14.0075 2.49951 14.0229 2.49988H16.6248C16.6326 2.49988 16.6417 2.49981 16.6518 2.49973C16.7504 2.49896 16.9544 2.49739 17.1551 2.55138C17.3247 2.59702 17.485 2.6721 17.6286 2.77319C17.7986 2.89281 17.928 3.0505 17.9905 3.12675C17.9969 3.13458 18.0026 3.14156 18.0076 3.14754L22.3538 8.36295C22.4181 8.44004 22.4971 8.53471 22.5611 8.62445C22.6368 8.73052 22.733 8.88458 22.7911 9.08838C22.8679 9.35734 22.8679 9.64241 22.7911 9.91137C22.733 10.1152 22.6368 10.2692 22.5611 10.3753C22.4971 10.465 22.4181 10.5597 22.3538 10.6368L13.3655 21.4228C13.2751 21.5313 13.1708 21.6566 13.0707 21.7574C12.958 21.871 12.7773 22.0316 12.5145 22.1277C12.1819 22.2492 11.8171 22.2492 11.4846 22.1277C11.2217 22.0316 11.0411 21.871 10.9284 21.7574C10.8283 21.6566 10.7239 21.5313 10.6336 21.4228L1.6581 10.6522C1.65389 10.6472 1.6496 10.642 1.64525 10.6368C1.58095 10.5597 1.50201 10.465 1.43796 10.3753C1.36225 10.2692 1.26608 10.1152 1.20794 9.91137C1.13121 9.6424 1.13121 9.35734 1.20794 9.08837C1.26608 8.88458 1.36225 8.73052 1.43796 8.62445C1.50201 8.53471 1.58097 8.44004 1.64526 8.36294C1.64961 8.35773 1.6539 8.35259 1.65811 8.34754L5.99144 3.14754C5.99643 3.14156 6.00215 3.13458 6.00858 3.12675C6.07112 3.0505 6.20048 2.89281 6.37044 2.77319C6.5141 2.6721 6.67439 2.59702 6.84402 2.55138C7.04472 2.49739 7.24867 2.49896 7.34729 2.49973ZM13.2788 4.49988H10.7203L9.38696 8.49988H14.6121L13.2788 4.49988ZM16.7203 8.49988L15.387 4.49988H16.5312L19.8645 8.49988H16.7203ZM14.5929 10.4999L11.9995 17.9559L9.40613 10.4999H14.5929ZM7.27878 8.49988L8.61211 4.49988H7.46791L4.13458 8.49988H7.27878ZM4.13458 10.4999H7.2886L9.54819 16.9962L4.13458 10.4999ZM14.4509 16.9962L16.7105 10.4999H19.8645L14.4509 16.9962ZM7.6005 4.34213C7.60061 4.34201 7.60062 4.342 7.6005 4.34213V4.34213ZM7.26187 4.50074C7.26169 4.50075 7.2617 4.50075 7.26187 4.50074V4.50074ZM16.7372 4.50074C16.7374 4.50075 16.7374 4.50075 16.7372 4.50074V4.50074ZM16.3986 4.34215C16.3985 4.34201 16.3985 4.34202 16.3986 4.34215V4.34215Z",
     :fill      "currentColor"}]])

(defn film
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M6.7587 1.5H17.2413C18.0463 1.49999 18.7106 1.49998 19.2518 1.54419C19.8139 1.59012 20.3306 1.68868 20.816 1.93597C21.5686 2.31947 22.1805 2.93139 22.564 3.68404C22.8113 4.16937 22.9099 4.68608 22.9558 5.24817C23 5.78936 23 6.45372 23 7.25868V17.7413C23 18.5463 23 19.2106 22.9558 19.7518C22.9099 20.3139 22.8113 20.8306 22.564 21.316C22.1805 22.0686 21.5686 22.6805 20.816 23.064C20.3306 23.3113 19.8139 23.4099 19.2518 23.4558C18.7106 23.5 18.0463 23.5 17.2413 23.5H6.75868C5.95372 23.5 5.28936 23.5 4.74817 23.4558C4.18608 23.4099 3.66937 23.3113 3.18404 23.064C2.43139 22.6805 1.81947 22.0686 1.43597 21.316C1.18868 20.8306 1.09012 20.3139 1.04419 19.7518C0.999977 19.2106 0.999988 18.5463 1 17.7413V7.2587C0.999988 6.45373 0.999977 5.78937 1.04419 5.24817C1.09012 4.68608 1.18868 4.16937 1.43597 3.68404C1.81947 2.93139 2.43139 2.31947 3.18404 1.93597C3.66937 1.68868 4.18608 1.59012 4.74817 1.54419C5.28937 1.49998 5.95373 1.49999 6.7587 1.5ZM3 8.5V11.5H6V8.5H3ZM6 6.5H3.00176C3.00489 6.05447 3.01357 5.70463 3.03755 5.41104C3.07337 4.97262 3.1383 4.74842 3.21799 4.59202C3.40973 4.2157 3.7157 3.90973 4.09202 3.71799C4.24842 3.6383 4.47262 3.57337 4.91104 3.53755C5.20463 3.51357 5.55447 3.50489 6 3.50176V6.5ZM8 11.5H16V3.5H8V11.5ZM18 3.50176V6.5H20.9982C20.9951 6.05447 20.9864 5.70463 20.9624 5.41104C20.9266 4.97262 20.8617 4.74842 20.782 4.59202C20.5903 4.2157 20.2843 3.90973 19.908 3.71799C19.7516 3.6383 19.5274 3.57337 19.089 3.53755C18.7954 3.51357 18.4455 3.50489 18 3.50176ZM21 8.5H18V11.5H21V8.5ZM21 13.5H18V16.5H21V13.5ZM20.9982 18.5H18V21.4982C18.4455 21.4951 18.7954 21.4864 19.089 21.4624C19.5274 21.4266 19.7516 21.3617 19.908 21.282C20.2843 21.0903 20.5903 20.7843 20.782 20.408C20.8617 20.2516 20.9266 20.0274 20.9624 19.589C20.9864 19.2954 20.9951 18.9455 20.9982 18.5ZM16 21.5V13.5H8V21.5H16ZM6 21.4982V18.5H3.00176C3.00489 18.9455 3.01357 19.2954 3.03755 19.589C3.07337 20.0274 3.1383 20.2516 3.21799 20.408C3.40973 20.7843 3.7157 21.0903 4.09202 21.282C4.24842 21.3617 4.47262 21.4266 4.91104 21.4624C5.20463 21.4864 5.55447 21.4951 6 21.4982ZM3 16.5H6V13.5H3V16.5Z",
     :fill      "currentColor"}]])

(defn tv-default
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M6.7587 2.5H17.2413C18.0463 2.49999 18.7106 2.49998 19.2518 2.54419C19.8139 2.59012 20.3306 2.68868 20.816 2.93597C21.5686 3.31947 22.1805 3.93139 22.564 4.68404C22.8113 5.16937 22.9099 5.68608 22.9558 6.24817C23 6.78936 23 7.45372 23 8.25868V12.7413C23 13.5463 23 14.2106 22.9558 14.7518C22.9099 15.3139 22.8113 15.8306 22.564 16.316C22.1805 17.0686 21.5686 17.6805 20.816 18.064C20.3306 18.3113 19.8139 18.4099 19.2518 18.4558C19.1707 18.4624 19.0868 18.4681 19 18.4729L19 19.9319C19 20.1843 19.0001 20.4301 18.9831 20.6382C18.9644 20.8668 18.9203 21.1366 18.782 21.408C18.5903 21.7843 18.2843 22.0903 17.908 22.282C17.6366 22.4203 17.3668 22.4644 17.1382 22.4831C16.9301 22.5001 16.6843 22.5 16.4319 22.5H7.56809C7.31571 22.5 7.06992 22.5001 6.86177 22.4831C6.63318 22.4644 6.36344 22.4203 6.09202 22.282C5.7157 22.0903 5.40974 21.7843 5.21799 21.408C5.07969 21.1366 5.03562 20.8668 5.01695 20.6382C4.99994 20.4301 4.99997 20.1843 5 19.9319L5 18.4729C4.91325 18.4681 4.82933 18.4624 4.74817 18.4558C4.18608 18.4099 3.66937 18.3113 3.18404 18.064C2.43139 17.6805 1.81947 17.0686 1.43597 16.316C1.18868 15.8306 1.09012 15.3139 1.04419 14.7518C0.999977 14.2106 0.999988 13.5463 1 12.7413V8.2587C0.999988 7.45373 0.999977 6.78937 1.04419 6.24818C1.09012 5.68608 1.18868 5.16937 1.43597 4.68404C1.81947 3.93139 2.43139 3.31947 3.18404 2.93597C3.66937 2.68868 4.18608 2.59012 4.74817 2.54419C5.28937 2.49998 5.95373 2.49999 6.7587 2.5ZM7 18.5V19.9C7 20.1965 7.00078 20.3588 7.0103 20.4754C7.01068 20.48 7.01107 20.4844 7.01145 20.4885C7.0156 20.4889 7.02 20.4893 7.02463 20.4897C7.14122 20.4992 7.30347 20.5 7.6 20.5H16.4C16.6965 20.5 16.8588 20.4992 16.9754 20.4897C16.98 20.4893 16.9844 20.4889 16.9886 20.4885C16.9889 20.4844 16.9893 20.48 16.9897 20.4754C16.9992 20.3588 17 20.1965 17 19.9V18.5H7ZM4.91104 4.53755C4.47262 4.57337 4.24842 4.6383 4.09202 4.71799C3.7157 4.90973 3.40973 5.2157 3.21799 5.59202C3.1383 5.74842 3.07337 5.97262 3.03755 6.41104C3.00078 6.86113 3 7.44342 3 8.3V12.7C3 13.5566 3.00078 14.1389 3.03755 14.589C3.07337 15.0274 3.1383 15.2516 3.21799 15.408C3.40973 15.7843 3.7157 16.0903 4.09202 16.282C4.24842 16.3617 4.47262 16.4266 4.91104 16.4624C5.36113 16.4992 5.94342 16.5 6.8 16.5H17.2C18.0566 16.5 18.6389 16.4992 19.089 16.4624C19.5274 16.4266 19.7516 16.3617 19.908 16.282C20.2843 16.0903 20.5903 15.7843 20.782 15.408C20.8617 15.2516 20.9266 15.0274 20.9624 14.589C20.9992 14.1389 21 13.5566 21 12.7V8.3C21 7.44342 20.9992 6.86113 20.9624 6.41104C20.9266 5.97262 20.8617 5.74842 20.782 5.59202C20.5903 5.2157 20.2843 4.90973 19.908 4.71799C19.7516 4.6383 19.5274 4.57337 19.089 4.53755C18.6389 4.50078 18.0566 4.5 17.2 4.5H6.8C5.94342 4.5 5.36113 4.50078 4.91104 4.53755Z",
     :fill      "currentColor"}]])

(defn tv-a
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M4 19C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V17C22 17.55 21.8042 18.0208 21.4125 18.4125C21.0208 18.8042 20.55 19 20 19H16V20C16 20.2833 15.9042 20.5208 15.7125 20.7125C15.5208 20.9042 15.2833 21 15 21H9C8.71667 21 8.47917 20.9042 8.2875 20.7125C8.09583 20.5208 8 20.2833 8 20V19H4ZM4 17H20V5H4V17Z",
     :fill      "currentColor"}]])

(defn- tv-variants []
  {:default tv-default
   :a       tv-a})

(defn tv [{:keys [variant]
           :or   {variant :default}}]
  (get (tv-variants) variant))

(defn stars
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 32 32",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d         "M25.3334 11.0676C25.2223 11.0676 25.1058 11.0342 24.9841 10.9676C24.8614 10.9009 24.7778 10.8009 24.7334 10.6676L23.6667 8.33425L21.3334 7.26758C21.2001 7.22313 21.1001 7.13958 21.0334 7.01691C20.9667 6.89513 20.9334 6.77869 20.9334 6.66758C20.9334 6.55647 20.9667 6.43958 21.0334 6.31691C21.1001 6.19513 21.2001 6.11202 21.3334 6.06758L23.6667 5.00091L24.7334 2.66758C24.7778 2.53424 24.8614 2.43424 24.9841 2.36758C25.1058 2.30091 25.2223 2.26758 25.3334 2.26758C25.4445 2.26758 25.5614 2.30091 25.6841 2.36758C25.8058 2.43424 25.889 2.53424 25.9334 2.66758L27.0001 5.00091L29.3334 6.06758C29.4667 6.11202 29.5667 6.19513 29.6334 6.31691C29.7001 6.43958 29.7334 6.55647 29.7334 6.66758C29.7334 6.77869 29.7001 6.89513 29.6334 7.01691C29.5667 7.13958 29.4667 7.22313 29.3334 7.26758L27.0001 8.33425L25.9334 10.6676C25.889 10.8009 25.8058 10.9009 25.6841 10.9676C25.5614 11.0342 25.4445 11.0676 25.3334 11.0676ZM25.3334 29.7342C25.2223 29.7342 25.1058 29.7009 24.9841 29.6342C24.8614 29.5676 24.7778 29.4676 24.7334 29.3342L23.6667 27.0009L21.3334 25.9342C21.2001 25.8898 21.1001 25.8062 21.0334 25.6836C20.9667 25.5618 20.9334 25.4454 20.9334 25.3342C20.9334 25.2231 20.9667 25.1067 21.0334 24.9849C21.1001 24.8622 21.2001 24.7787 21.3334 24.7342L23.6667 23.6676L24.7334 21.3342C24.7778 21.2009 24.8614 21.1009 24.9841 21.0342C25.1058 20.9676 25.2223 20.9342 25.3334 20.9342C25.4445 20.9342 25.5614 20.9676 25.6841 21.0342C25.8058 21.1009 25.889 21.2009 25.9334 21.3342L27.0001 23.6676L29.3334 24.7342C29.4667 24.7787 29.5667 24.8622 29.6334 24.9849C29.7001 25.1067 29.7334 25.2231 29.7334 25.3342C29.7334 25.4454 29.7001 25.5618 29.6334 25.6836C29.5667 25.8062 29.4667 25.8898 29.3334 25.9342L27.0001 27.0009L25.9334 29.3342C25.889 29.4676 25.8058 29.5676 25.6841 29.6342C25.5614 29.7009 25.4445 29.7342 25.3334 29.7342ZM12.0001 24.7676C11.7556 24.7676 11.5223 24.7009 11.3001 24.5676C11.0778 24.4342 10.9112 24.2454 10.8001 24.0009L8.66673 19.3342L4.00007 17.2009C3.75562 17.0898 3.56673 16.9231 3.4334 16.7009C3.30007 16.4787 3.2334 16.2454 3.2334 16.0009C3.2334 15.7565 3.30007 15.5231 3.4334 15.3009C3.56673 15.0787 3.75562 14.912 4.00007 14.8009L8.66673 12.6676L10.8001 8.00091C10.9112 7.75647 11.0778 7.56758 11.3001 7.43424C11.5223 7.30091 11.7556 7.23425 12.0001 7.23425C12.2445 7.23425 12.4778 7.30091 12.7001 7.43424C12.9223 7.56758 13.089 7.75647 13.2001 8.00091L15.3334 12.6676L20.0001 14.8009C20.2445 14.912 20.4334 15.0787 20.5667 15.3009C20.7001 15.5231 20.7667 15.7565 20.7667 16.0009C20.7667 16.2454 20.7001 16.4787 20.5667 16.7009C20.4334 16.9231 20.2445 17.0898 20.0001 17.2009L15.3334 19.3342L13.2001 24.0009C13.089 24.2454 12.9223 24.4342 12.7001 24.5676C12.4778 24.7009 12.2445 24.7676 12.0001 24.7676Z",
     :fill      "currentColor"}]])

(defn toy
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M7.291 20.834a3.064 3.064 0 0 1-2.045-.742c-.581-.495-.924-1.133-1.028-1.914a3.895 3.895 0 0 1-1.563-1.484 4.052 4.052 0 0 1-.573-2.109c0-.92.266-1.741.795-2.461.53-.72 1.237-1.22 2.123-1.498L3.125 8.75l-.313.313c-.191.191-.434.287-.73.287s-.538-.095-.729-.287c-.191-.191-.287-.434-.287-.729s.095-.539.287-.73l2.085-2.083c.191-.191.434-.287.729-.287s.538.095.729.287c.191.191.287.434.287.729s-.095.538-.287.73l-.313.313L6.041 8.75l.834-2.448a2.99 2.99 0 0 1 1.133-1.55 3.082 3.082 0 0 1 1.836-.586h5.313c.677 0 1.289.195 1.836.586.547.391.924.908 1.133 1.55l1.406 4.219a4.068 4.068 0 0 1 2.434 1.432 4.002 4.002 0 0 1 .951 2.63c0 .764-.191 1.467-.573 2.109a3.895 3.895 0 0 1-1.563 1.484c-.105.781-.448 1.42-1.029 1.914a3.057 3.057 0 0 1-2.045.742 2.976 2.976 0 0 1-1.784-.573 3.128 3.128 0 0 1-1.132-1.509h-4.584a3.128 3.128 0 0 1-1.133 1.51 2.976 2.976 0 0 1-1.784.573Zm.416-10.417h3.75V6.25H9.844a.975.975 0 0 0-.599.195 1.177 1.177 0 0 0-.391.534l-1.146 3.438Zm5.834 0h3.75l-1.146-3.438a1.177 1.177 0 0 0-.391-.534.972.972 0 0 0-.598-.195h-1.614v4.167Zm-3.334 6.25h4.584a3.127 3.127 0 0 1 1.133-1.51 2.977 2.977 0 0 1 1.784-.573 3.03 3.03 0 0 1 1.459.364 3.48 3.48 0 0 1 1.145.99c.156-.191.283-.403.378-.637a2.005 2.005 0 0 0-.469-2.188 2.006 2.006 0 0 0-1.471-.613H6.25c-.573 0-1.064.204-1.472.613a2.006 2.006 0 0 0-.612 1.471c0 .242.048.481.143.716.095.234.222.448.378.638a3.492 3.492 0 0 1 1.145-.989 3.029 3.029 0 0 1 1.459-.365 2.977 2.977 0 0 1 1.784.573 3.128 3.128 0 0 1 1.133 1.511ZM7.291 18.75c.295 0 .542-.1.742-.299a1.008 1.008 0 0 0 .299-.742 1.008 1.008 0 0 0-.299-.742 1.008 1.008 0 0 0-.742-.299 1.008 1.008 0 0 0-.742.299 1.008 1.008 0 0 0-.299.742c0 .295.099.542.299.742.199.199.447.299.742.299Zm10.416 0c.295 0 .543-.1.742-.299a1.008 1.008 0 0 0 .3-.742 1.008 1.008 0 0 0-.3-.742 1.008 1.008 0 0 0-.742-.299 1.008 1.008 0 0 0-.742.299 1.008 1.008 0 0 0-.299.742c0 .295.1.542.299.742.2.199.447.299.742.299Z",
     :fill      "currentColor"}]])

(defn school
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M11.434 21.346a2.029 2.029 0 0 1 -0.999 -0.262l-5.257 -2.839a2.107 2.107 0 0 1 -0.815 -0.776 2.096 2.096 0 0 1 -0.289 -1.091V11.332L1.552 9.94a1.022 1.022 0 0 1 -0.42 -0.395 1.064 1.064 0 0 1 -0.132 -0.525c0 -0.194 0.044 -0.368 0.131 -0.526 0.088 -0.158 0.228 -0.289 0.421 -0.395l8.884 -4.838a2.027 2.027 0 0 1 1.997 0l10.014 5.468c0.176 0.088 0.311 0.214 0.408 0.38 0.096 0.167 0.144 0.347 0.144 0.54v6.728c0 0.298 -0.101 0.547 -0.302 0.748 -0.202 0.203 -0.451 0.303 -0.748 0.303 -0.298 0 -0.547 -0.101 -0.749 -0.303a1.013 1.013 0 0 1 -0.302 -0.748v-6.202l-2.103 1.157v5.046c0 0.404 -0.097 0.767 -0.289 1.091a2.103 2.103 0 0 1 -0.815 0.776l-5.258 2.838a2.021 2.021 0 0 1 -0.998 0.263Zm0 -8.438 7.202 -3.89 -7.202 -3.889 -7.202 3.889 7.202 3.89Zm0 6.335 5.258 -2.839v-3.969l-4.232 2.34a2.147 2.147 0 0 1 -1.551 0.197 2.032 2.032 0 0 1 -0.5 -0.197l-4.232 -2.34v3.969l5.258 2.839Z",
     :fill      "currentColor"}]])

(defn certified
  []
  [:svg {:width 24
         :height 24
         :viewBox "0 0 32 32"
         :fill "none"
         :xmlns "http://www.w3.org/2000/svg"}
   [:g {:clip-path "url(#clip0_3730_23523)"}
    [:mask {:id "mask0_3730_23523"
            :style {:mask-type "alpha"}
            :maskUnits "userSpaceOnUse"
            :x "0"
            :y "0"
            :width  32
            :height 32}
     [:rect {:width 32
             :height 32
             :fill "currentColor"}]]
    [:g {:mask "url(#mask0_3730_23523)"}
     [:path {:d "M8.93327 25.7343L5.2666 24.9343C4.93327 24.8676 4.6666 24.6951 4.4666 24.4169C4.2666 24.1396 4.18882 23.8343 4.23327 23.5009L4.59994 19.7343L2.09993 16.8676C1.87771 16.6231 1.7666 16.3343 1.7666 16.0009C1.7666 15.6676 1.87771 15.3787 2.09993 15.1343L4.59994 12.2676L4.23327 8.50093C4.18882 8.16759 4.2666 7.86226 4.4666 7.58493C4.6666 7.3067 4.93327 7.13426 5.2666 7.06759L8.93327 6.26759L10.8666 3.00093C11.0444 2.71204 11.2888 2.52315 11.5999 2.43426C11.911 2.34537 12.2222 2.35648 12.5333 2.46759L15.9999 3.93426L19.4666 2.46759C19.7777 2.35648 20.0888 2.34537 20.3999 2.43426C20.711 2.52315 20.9555 2.71204 21.1333 3.00093L23.0666 6.26759L26.7333 7.06759C27.0666 7.13426 27.3333 7.3067 27.5333 7.58493C27.7333 7.86226 27.811 8.16759 27.7666 8.50093L27.3999 12.2676L29.8999 15.1343C30.1222 15.3787 30.2333 15.6676 30.2333 16.0009C30.2333 16.3343 30.1222 16.6231 29.8999 16.8676L27.3999 19.7343L27.7666 23.5009C27.811 23.8343 27.7333 24.1396 27.5333 24.4169C27.3333 24.6951 27.0666 24.8676 26.7333 24.9343L23.0666 25.7343L21.1333 29.0009C20.9555 29.2898 20.711 29.4787 20.3999 29.5676C20.0888 29.6565 19.7777 29.6454 19.4666 29.5343L15.9999 28.0676L12.5333 29.5343C12.2222 29.6454 11.911 29.6565 11.5999 29.5676C11.2888 29.4787 11.0444 29.2898 10.8666 29.0009L8.93327 25.7343ZM13.6666 19.8009C13.911 20.0454 14.2222 20.1676 14.5999 20.1676C14.9777 20.1676 15.2888 20.0454 15.5333 19.8009L21.1999 14.1343C21.4666 13.8676 21.5999 13.5507 21.5999 13.1836C21.5999 12.8174 21.4666 12.5009 21.1999 12.2343C20.9333 11.9676 20.6168 11.8343 20.2506 11.8343C19.8835 11.8343 19.5666 11.9676 19.2999 12.2343L14.5999 16.9343L12.6666 15.0343C12.3999 14.7898 12.0835 14.6729 11.7173 14.6836C11.3502 14.6951 11.0444 14.8231 10.7999 15.0676C10.5555 15.312 10.4333 15.6231 10.4333 16.0009C10.4333 16.3787 10.5555 16.6898 10.7999 16.9343L13.6666 19.8009ZM12.5999 26.6009L15.9999 25.1343L19.4666 26.6009L21.3333 23.4009L24.9999 22.5343L24.6666 18.8009L27.1333 16.0009L24.6666 13.1343L24.9999 9.40093L21.3333 8.60092L19.3999 5.40093L15.9999 6.86759L12.5333 5.40093L10.6666 8.60092L6.99994 9.40093L7.33327 13.1343L4.8666 16.0009L7.33327 18.8009L6.99994 22.6009L10.6666 23.4009L12.5999 26.6009Z"
             :fill "currentColor"}]]]
   [:defs
    [:clipPath {:id "clip0_3730_23523"}
     [:rect {:width 32
             :height 32
             :fill "currentColor"}]]]])

(defn medal
  [{:keys [width height]}]
  [:svg {:width width
         :height height
         :viewBox "0 0 64 64"
         :fill "none"
         :xmlns "http://www.w3.org/2000/svg"}
   [:mask {:id "mask0_3735_23157"
           :style {:mask-type "alpha"}
           :maskUnits "userSpaceOnUse"
           :x "0"
           :y "0"
           :width "64"
           :height "64"}
    [:rect {:width "64"
            :height "64"
            :fill "currentColor"}]]
   [:g {:mask "url(#mask0_3735_23157)"}
    [:path {:d "M29.1845 33.6146L31.9999 31.466L34.7743 33.6146C35.2461 33.9804 35.741 33.9916 36.2589 33.648C36.7768 33.3044 36.9332 32.8472 36.7281 32.2762L35.6204 28.7275L38.564 26.4762C39.0358 26.1104 39.176 25.6489 38.9845 25.0916C38.7931 24.5343 38.4119 24.2557 37.8409 24.2557H34.2461L33.164 20.7993C32.9589 20.2284 32.5709 19.9429 31.9999 19.9429C31.429 19.9429 31.041 20.2284 30.8359 20.7993L29.7538 24.2557H26.1589C25.588 24.2557 25.2 24.5412 24.9949 25.1122C24.7897 25.6831 24.923 26.1378 25.3949 26.4762L28.3384 28.7275L27.2307 32.2762C27.0256 32.8472 27.1752 33.3044 27.6795 33.648C28.1837 33.9916 28.6854 33.9804 29.1845 33.6146ZM20.4821 58.2607C19.6958 58.5376 18.9744 58.4307 18.318 57.9402C17.6616 57.4496 17.3333 56.8026 17.3333 55.9992V40.1941C15.6444 38.43 14.3333 36.3907 13.4 34.0762C12.4667 31.7617 12 29.2916 12 26.666C12 21.0865 13.9385 16.3583 17.8154 12.4814C21.6923 8.60448 26.4205 6.66602 31.9999 6.66602C37.5794 6.66602 42.3076 8.60448 46.1845 12.4814C50.0614 16.3583 51.9999 21.0865 51.9999 26.666C51.9999 29.2916 51.5332 31.7617 50.5999 34.0762C49.6665 36.3907 48.3554 38.43 46.6665 40.1941V55.9992C46.6665 56.8026 46.3383 57.4496 45.6819 57.9402C45.0255 58.4308 44.3041 58.5376 43.5178 58.2607L31.9999 54.6146L20.4821 58.2607ZM31.9999 42.666C36.4444 42.666 40.2222 41.1104 43.3333 37.9993C46.4444 34.8882 47.9999 31.1104 47.9999 26.666C47.9999 22.2215 46.4444 18.4437 43.3333 15.3326C40.2222 12.2215 36.4444 10.666 31.9999 10.666C27.5555 10.666 23.7777 12.2215 20.6666 15.3326C17.5555 18.4437 15.9999 22.2215 15.9999 26.666C15.9999 31.1104 17.5555 34.8882 20.6666 37.9993C23.7777 41.1104 27.5555 42.666 31.9999 42.666ZM21.3333 53.425L31.9999 50.5634L42.6666 53.425V43.5171C41.1452 44.5085 39.4803 45.2812 37.6717 45.8351C35.8632 46.389 33.9726 46.6659 31.9999 46.6659C30.0273 46.6659 28.1367 46.389 26.3281 45.8351C24.5196 45.2812 22.8546 44.5085 21.3333 43.5171V53.425Z"
            :fill "currentColor"}]]])

(defn space
  [{:keys [width height]}]
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width (or width 16),
    :height (or height 12),
    :view-box "0 0 16 12",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M0.333496 5.5V0.5H2.00016V3.83333H12.0002V0.5H13.6668V5.5H0.333496Z",
     :fill      "currentColor"}]])

(defn backspace
  [{:keys [width height]}]
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width (or width 16),
    :height (or height 12),
    :view-box "0 0 16 12",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M6.917 8.75a.79.79 0 0 0 .583.229.79.79 0 0 0 .584-.23l1.583-1.583 1.583 1.583a.79.79 0 0 0 .584.23.79.79 0 0 0 .583-.23.79.79 0 0 0 .229-.583.79.79 0 0 0-.23-.583l-1.582-1.584 1.583-1.583a.79.79 0 0 0 .229-.583.79.79 0 0 0-.23-.584.79.79 0 0 0-.582-.229.79.79 0 0 0-.584.23L9.667 4.832 8.084 3.249A.79.79 0 0 0 7.5 3.02a.79.79 0 0 0-.583.23.79.79 0 0 0-.23.583c0 .236.077.43.23.583L8.5 5.999 6.917 7.583a.79.79 0 0 0-.23.583c0 .236.077.43.23.583ZM5.5 11.832a1.69 1.69 0 0 1-.782-.188 1.593 1.593 0 0 1-.593-.52L1.188 6.957a1.692 1.692 0 0 1-.292-.959c0-.347.097-.666.292-.958L4.125.874c.153-.222.35-.395.593-.52A1.69 1.69 0 0 1 5.5.166h8.334c.458 0 .85.163 1.177.49.326.326.49.718.49 1.177v8.333c0 .458-.164.85-.49 1.178-.327.326-.72.489-1.177.489H5.5ZM2.542 5.999 5.5 10.166h8.334V1.833H5.5L2.542 5.999Z",
     :fill      "currentColor"}]])

(defn opened-lock
  [{:keys [width height]}]
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width (or width 11),
    :height (or height 14),
    :view-box "0 0 11 14",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M1.53 13.25c-.344 0-.638-.122-.883-.367A1.204 1.204 0 0 1 .28 12V5.75c0-.344.122-.638.367-.883s.539-.367.883-.367h5.625V3.25c0-.52-.183-.964-.547-1.328a1.808 1.808 0 0 0-1.328-.547c-.438 0-.82.133-1.149.398-.328.266-.55.597-.664.993a.621.621 0 0 1-.258.351.748.748 0 0 1-.43.133.62.62 0 0 1-.445-.172.418.418 0 0 1-.132-.406c.114-.708.46-1.31 1.039-1.805A3.037 3.037 0 0 1 5.28.125c.864 0 1.601.305 2.21.914.61.61.915 1.346.915 2.211V4.5h.625c.344 0 .638.122.883.367.244.245.367.54.367.883V12c0 .344-.123.638-.367.883-.245.245-.54.367-.883.367h-7.5Zm3.75-3.125c.344 0 .638-.122.883-.367.244-.245.367-.54.367-.883 0-.344-.123-.638-.367-.883a1.204 1.204 0 0 0-.883-.367c-.344 0-.638.122-.883.367s-.367.54-.367.883c0 .344.122.638.367.883s.539.367.883.367Z",
     :fill      "currentColor"}]])

(defn lock
  [{:keys [width height]}]
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width (or width 11),
    :height (or height 14),
    :view-box "0 0 11 14",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M1.75 13.75a1.2 1.2 0 0 1-.882-.367A1.204 1.204 0 0 1 .5 12.5V6.25c0-.344.123-.638.368-.883A1.2 1.2 0 0 1 1.75 5h.625V3.75c0-.865.305-1.602.914-2.211A3.011 3.011 0 0 1 5.5.625c.865 0 1.602.305 2.211.914.61.61.914 1.346.914 2.211V5h.625c.344 0 .638.122.883.367s.367.54.367.883v6.25c0 .344-.122.638-.367.883s-.54.367-.883.367h-7.5Zm3.75-3.125c.344 0 .638-.122.883-.367s.367-.54.367-.883c0-.344-.122-.638-.367-.883a1.205 1.205 0 0 0-.883-.367c-.344 0-.638.122-.883.367s-.367.54-.367.883c0 .344.122.638.367.883s.54.367.883.367ZM3.625 5h3.75V3.75c0-.52-.182-.964-.547-1.328A1.808 1.808 0 0 0 5.5 1.875c-.52 0-.964.182-1.328.547a1.808 1.808 0 0 0-.547 1.328V5Z",
     :fill      "currentColor"}]])

(defn verified
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "m6.7 19.3-2.749-.6a.939.939 0 0 1-.6-.388.926.926 0 0 1-.176-.687L3.45 14.8l-1.875-2.15a.934.934 0 0 1-.25-.65c0-.25.083-.467.25-.65L3.45 9.2l-.275-2.825a.926.926 0 0 1 .176-.687.941.941 0 0 1 .6-.388L6.7 4.7l1.45-2.45a.93.93 0 0 1 .55-.425c.233-.067.467-.058.7.026L12 2.95l2.6-1.099c.232-.083.467-.092.7-.026a.937.937 0 0 1 .55.425L17.3 4.7l2.749.6c.251.05.45.179.6.388.15.208.209.437.176.687L20.55 9.2l1.875 2.15c.167.184.25.401.25.65 0 .25-.083.467-.25.65L20.55 14.8l.275 2.825a.928.928 0 0 1-.176.687.941.941 0 0 1-.6.388l-2.749.6-1.45 2.45a.929.929 0 0 1-.55.425 1.119 1.119 0 0 1-.7-.026L12 21.05l-2.6 1.099a1.119 1.119 0 0 1-.7.026.929.929 0 0 1-.55-.425L6.7 19.3Zm3.55-4.45c.183.183.416.275.7.275s.517-.092.7-.275l4.25-4.25c.2-.2.3-.437.3-.712s-.1-.512-.3-.712a.973.973 0 0 0-.712-.3.978.978 0 0 0-.712.3l-3.525 3.525-1.45-1.425a.974.974 0 0 0-.712-.262.978.978 0 0 0-.688.288c-.184.183-.275.416-.275.7s.092.517.275.7l2.15 2.15Zm-.8 5.1 2.55-1.1 2.6 1.1 1.4-2.4 2.75-.65-.25-2.8 1.85-2.1-1.85-2.15.25-2.8-2.75-.6-1.45-2.4L12 5.15l-2.6-1.1L8 6.45l-2.75.6.25 2.8L3.65 12l1.85 2.1-.25 2.85 2.75.6 1.45 2.4Z",
     :fill      "currentColor"}]])

(defn book-open
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M5.16146 3.5L5.64281 3.5C6.72659 3.49999 7.60075 3.49998 8.30863 3.55782C9.03748 3.61737 9.67766 3.74318 10.27 4.04497C10.9535 4.39326 11.5442 4.89228 12 5.49999C12.4558 4.89228 13.0465 4.39326 13.73 4.04497C14.3223 3.74318 14.9625 3.61737 15.6914 3.55782C16.3993 3.49998 17.2734 3.49999 18.3572 3.5L18.8385 3.5C19.3657 3.49998 19.8205 3.49997 20.195 3.53057C20.5904 3.56287 20.9836 3.63419 21.362 3.82698C21.9265 4.1146 22.3854 4.57354 22.673 5.13803C22.8658 5.51641 22.9371 5.90963 22.9694 6.30497C23 6.67954 23 7.1343 23 7.66144V17.3386C23 17.8657 23 18.3205 22.9694 18.695C22.9371 19.0904 22.8658 19.4836 22.673 19.862C22.3854 20.4265 21.9265 20.8854 21.362 21.173C20.9836 21.3658 20.5904 21.4371 20.195 21.4694C19.8205 21.5 19.3657 21.5 18.8386 21.5H5.16144C4.6343 21.5 4.17954 21.5 3.80497 21.4694C3.40963 21.4371 3.01641 21.3658 2.63803 21.173C2.07354 20.8854 1.6146 20.4265 1.32698 19.862C1.13419 19.4836 1.06287 19.0904 1.03057 18.695C0.999967 18.3205 0.999983 17.8657 1 17.3385V7.66146C0.999983 7.13431 0.999967 6.67955 1.03057 6.30497C1.06287 5.90963 1.13419 5.51641 1.32698 5.13803C1.6146 4.57354 2.07354 4.1146 2.63803 3.82698C3.01641 3.63419 3.40963 3.56287 3.80497 3.53057C4.17955 3.49997 4.63431 3.49998 5.16146 3.5ZM11 10.9C11 9.7634 10.9992 8.97108 10.9488 8.35424C10.8994 7.74907 10.8072 7.40139 10.673 7.13803C10.3854 6.57354 9.92646 6.1146 9.36197 5.82698C9.09862 5.6928 8.75093 5.60062 8.14576 5.55118C7.52892 5.50078 6.73661 5.5 5.6 5.5H5.2C4.62345 5.5 4.25117 5.50078 3.96784 5.52393C3.69617 5.54612 3.59546 5.5838 3.54601 5.609C3.35785 5.70487 3.20487 5.85785 3.109 6.04601C3.0838 6.09546 3.04612 6.19617 3.02393 6.46784C3.00078 6.75117 3 7.12345 3 7.7V17.3C3 17.8766 3.00078 18.2488 3.02393 18.5322C3.04612 18.8038 3.0838 18.9045 3.109 18.954C3.20487 19.1422 3.35785 19.2951 3.54601 19.391C3.59546 19.4162 3.69617 19.4539 3.96784 19.4761C4.25117 19.4992 4.62345 19.5 5.2 19.5H11V10.9ZM13 19.5V10.9C13 9.7634 13.0008 8.97108 13.0512 8.35424C13.1006 7.74907 13.1928 7.40139 13.327 7.13803C13.6146 6.57354 14.0735 6.1146 14.638 5.82698C14.9014 5.6928 15.2491 5.60062 15.8542 5.55118C16.4711 5.50078 17.2634 5.5 18.4 5.5H18.8C19.3766 5.5 19.7488 5.50078 20.0322 5.52393C20.3038 5.54612 20.4046 5.5838 20.454 5.609C20.6422 5.70487 20.7951 5.85785 20.891 6.04601C20.9162 6.09546 20.9539 6.19617 20.9761 6.46784C20.9992 6.75117 21 7.12345 21 7.7V17.3C21 17.8766 20.9992 18.2488 20.9761 18.5322C20.9539 18.8038 20.9162 18.9045 20.891 18.954C20.7951 19.1422 20.6422 19.2951 20.454 19.391C20.4045 19.4162 20.3038 19.4539 20.0322 19.4761C19.7488 19.4992 19.3766 19.5 18.8 19.5H13Z",
     :fill      "currentColor"}]])

(defn scissors
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M6 4.5C4.89543 4.5 4 5.39543 4 6.5C4 7.60457 4.89543 8.5 6 8.5C7.10457 8.5 8 7.60457 8 6.5C8 5.39543 7.10457 4.5 6 4.5ZM2 6.5C2 4.29086 3.79086 2.5 6 2.5C8.20914 2.5 10 4.29086 10 6.5C10 7.24181 9.79807 7.93645 9.44618 8.53197L12 11.0858L19.2929 3.79289C19.6834 3.40237 20.3166 3.40237 20.7071 3.79289C21.0976 4.18342 21.0976 4.81658 20.7071 5.20711L13.4142 12.5L20.7071 19.7929C21.0976 20.1834 21.0976 20.8166 20.7071 21.2071C20.3166 21.5976 19.6834 21.5976 19.2929 21.2071L12 13.9142L9.44618 16.468C9.79807 17.0635 10 17.7582 10 18.5C10 20.7091 8.20914 22.5 6 22.5C3.79086 22.5 2 20.7091 2 18.5C2 16.2909 3.79086 14.5 6 14.5C6.74181 14.5 7.43645 14.7019 8.03197 15.0538L10.5858 12.5L8.03197 9.94618C7.43645 10.2981 6.74181 10.5 6 10.5C3.79086 10.5 2 8.70914 2 6.5ZM16.5 12.5C16.5 11.9477 16.9477 11.5 17.5 11.5H17.51C18.0623 11.5 18.51 11.9477 18.51 12.5C18.51 13.0523 18.0623 13.5 17.51 13.5H17.5C16.9477 13.5 16.5 13.0523 16.5 12.5ZM21 12.5C21 11.9477 21.4477 11.5 22 11.5H22.01C22.5623 11.5 23.01 11.9477 23.01 12.5C23.01 13.0523 22.5623 13.5 22.01 13.5H22C21.4477 13.5 21 13.0523 21 12.5ZM6 16.5C4.89543 16.5 4 17.3954 4 18.5C4 19.6046 4.89543 20.5 6 20.5C7.10457 20.5 8 19.6046 8 18.5C8 17.3954 7.10457 16.5 6 16.5Z",
     :fill      "currentColor"}]])

(defn plus
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M12 4.5C12.5523 4.5 13 4.94772 13 5.5V11.5H19C19.5523 11.5 20 11.9477 20 12.5C20 13.0523 19.5523 13.5 19 13.5H13V19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5V13.5H5C4.44772 13.5 4 13.0523 4 12.5C4 11.9477 4.44772 11.5 5 11.5H11V5.5C11 4.94772 11.4477 4.5 12 4.5Z",
     :fill      "currentColor"}]])

(defn log-out
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M8.07123 3.05742L9.12878 3.17492C9.14332 3.17654 9.15765 3.17813 9.17177 3.1797C9.42373 3.20765 9.61105 3.22843 9.78005 3.26203C11.5265 3.60927 12.8331 5.06911 12.9854 6.8432C13.0001 7.01488 13.0001 7.20334 13 7.45684C13 7.47105 13 7.48547 13 7.5001C13 8.05239 12.5523 8.5001 12 8.5001C11.4477 8.5001 11 8.05239 11 7.5001C11 7.18453 10.9991 7.08897 10.9927 7.01422C10.9165 6.12717 10.2632 5.39725 9.39002 5.22363C9.31644 5.209 9.22157 5.19754 8.90792 5.16269L7.88651 5.0492C7.10494 4.96236 6.57081 4.90361 6.15481 4.8871C5.74652 4.87091 5.53541 4.90066 5.39044 4.94705C4.84862 5.12044 4.40628 5.51635 4.17412 6.03571C4.11201 6.17467 4.05912 6.38121 4.03013 6.78878C4.00059 7.20407 4 7.74141 4 8.5278V16.4724C4 17.2588 4.00059 17.7961 4.03013 18.2114C4.05912 18.619 4.112 18.8255 4.17412 18.9645C4.40628 19.4839 4.84862 19.8798 5.39044 20.0532C5.5354 20.0995 5.74652 20.1293 6.15481 20.1131C6.57082 20.0966 7.10495 20.0378 7.88651 19.951L8.90792 19.8375C9.22147 19.8027 9.31646 19.7912 9.39002 19.7766C10.2632 19.603 10.9165 18.873 10.9927 17.986C10.9991 17.9112 11 17.8157 11 17.5001C11 16.9478 11.4477 16.5001 12 16.5001C12.5523 16.5001 13 16.9478 13 17.5001C13 17.5147 13 17.5292 13 17.5434C13.0001 17.7969 13.0001 17.9853 12.9854 18.157C12.8331 19.9311 11.5265 21.3909 9.78005 21.7382C9.61105 21.7718 9.4236 21.7926 9.17168 21.8205L8.07121 21.9428C7.3347 22.0246 6.72964 22.0919 6.2341 22.1115C5.72276 22.1318 5.24547 22.1067 4.78088 21.958C3.69724 21.6112 2.81255 20.8194 2.34824 19.7807C2.14917 19.3354 2.07147 18.8638 2.03517 18.3533C1.99998 17.8586 1.99999 17.2498 2 16.5088V8.49144C1.99999 7.75037 1.99998 7.14158 2.03517 6.64689C2.07147 6.13644 2.14918 5.66485 2.34824 5.21953C2.81256 4.18081 3.69724 3.38897 4.78089 3.04221C5.24547 2.89354 5.72275 2.86839 6.23409 2.88868C6.72964 2.90834 7.3347 2.97557 8.07123 3.05742ZM15.2929 6.793C15.6834 6.40247 16.3166 6.40247 16.7071 6.793L21.7071 11.793C22.0976 12.1835 22.0976 12.8167 21.7071 13.2072L16.7071 18.2072C16.3166 18.5977 15.6834 18.5977 15.2929 18.2072C14.9024 17.8167 14.9024 17.1835 15.2929 16.793L18.5858 13.5001H9C8.44772 13.5001 8 13.0524 8 12.5001C8 11.9478 8.44772 11.5001 9 11.5001H18.5858L15.2929 8.20721C14.9024 7.81669 14.9024 7.18352 15.2929 6.793Z",
     :fill      "currentColor"}]])

(defn search
  [{:keys [class width height]}]
  [:svg
   {:class class
    :xmlns "http://www.w3.org/2000/svg",
    :width (or width 25),
    :height (or height 25),
    :view-box "0 0 24 25",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M10 4.5C6.68629 4.5 4 7.18629 4 10.5C4 13.8137 6.68629 16.5 10 16.5C13.3137 16.5 16 13.8137 16 10.5C16 7.18629 13.3137 4.5 10 4.5ZM2 10.5C2 6.08172 5.58172 2.5 10 2.5C14.4183 2.5 18 6.08172 18 10.5C18 12.3487 17.3729 14.0509 16.3199 15.4056L21.7071 20.7929C22.0976 21.1834 22.0976 21.8166 21.7071 22.2071C21.3166 22.5976 20.6834 22.5976 20.2929 22.2071L14.9057 16.8198C13.551 17.8729 11.8487 18.5 10 18.5C5.58172 18.5 2 14.9183 2 10.5Z",
     :fill      "currentColor"}]])

(defn live
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 24",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M2 10.785C2 5.35835 6.50023 1 12 1C17.4998 1 22 5.35835 22 10.785C22 14.1319 20.2788 17.0701 17.6791 18.8283C17.2216 19.1377 16.5999 19.0177 16.2905 18.5602C15.9811 18.1027 16.1012 17.4811 16.5586 17.1717C18.6458 15.7601 20 13.4239 20 10.785C20 6.50824 16.4411 3 12 3C7.55893 3 4 6.50824 4 10.785C4 13.4239 5.3542 15.7601 7.44135 17.1717C7.89883 17.4811 8.01887 18.1027 7.70947 18.5602C7.40006 19.0177 6.77838 19.1377 6.3209 18.8283C3.72122 17.0701 2 14.1319 2 10.785ZM12 7C9.74225 7 8 8.727 8 10.7505C8 11.7251 8.40019 12.6191 9.07055 13.2967C9.45898 13.6893 9.45558 14.3225 9.06297 14.7109C8.67036 15.0993 8.03721 15.0959 7.64878 14.7033C6.63731 13.6809 6 12.2922 6 10.7505C6 7.52721 8.73536 5 12 5C15.2646 5 18 7.52721 18 10.7505C18 12.2931 17.3626 13.681 16.3512 14.7033C15.9628 15.0959 15.3296 15.0993 14.937 14.7109C14.5444 14.3225 14.541 13.6893 14.9294 13.2967C15.5999 12.619 16 11.7259 16 10.7505C16 8.727 14.2578 7 12 7ZM10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11ZM9 18C9 16.3431 10.3431 15 12 15C13.6569 15 15 16.3431 15 18V20C15 21.6569 13.6569 23 12 23C10.3431 23 9 21.6569 9 20V18ZM12 17C11.4477 17 11 17.4477 11 18V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V18C13 17.4477 12.5523 17 12 17Z",
     :fill      "currentColor"}]])

(defn people [{:keys [fill]
               :or   {fill "none"}}]
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill fill}
   [:path
    {:d
     "M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M16.9699 14.44C18.3399 14.67 19.8499 14.43 20.9099 13.72C22.3199 12.78 22.3199 11.24 20.9099 10.3C19.8399 9.59004 18.3099 9.35003 16.9399 9.59003",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M5.96998 7.16C6.02998 7.15 6.09998 7.15 6.15998 7.16C7.53998 7.11 8.63998 5.98 8.63998 4.58C8.63998 3.15 7.48998 2 6.05998 2C4.62998 2 3.47998 3.16 3.47998 4.58C3.48998 5.98 4.58998 7.11 5.96998 7.16Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M6.99994 14.44C5.62994 14.67 4.11994 14.43 3.05994 13.72C1.64994 12.78 1.64994 11.24 3.05994 10.3C4.12994 9.59004 5.65994 9.35003 7.02994 9.59003",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M12 14.63C11.94 14.62 11.87 14.62 11.81 14.63C10.43 14.58 9.32996 13.45 9.32996 12.05C9.32996 10.62 10.48 9.46997 11.91 9.46997C13.34 9.46997 14.49 10.63 14.49 12.05C14.48 13.45 13.38 14.59 12 14.63Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M9.08997 17.78C7.67997 18.72 7.67997 20.26 9.08997 21.2C10.69 22.27 13.31 22.27 14.91 21.2C16.32 20.26 16.32 18.72 14.91 17.78C13.32 16.72 10.69 16.72 9.08997 17.78Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn message [{:keys [fill inner-stroke]
                :or   {fill         "none"
                       inner-stroke "currentColor"}}]
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill fill}
   [:path
    {:d
     "M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M15.9965 11H16.0054",
     :stroke inner-stroke,
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M11.9955 11H12.0045",
     :stroke inner-stroke,
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M7.99451 11H8.00349",
     :stroke inner-stroke,
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn chart [{:keys [fill inner-stroke]
              :or   {fill         "none"
                     inner-stroke "currentColor"}}]
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill fill}
   [:path
    {:d
     "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M7 10.74V13.94",
     :stroke inner-stroke,
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M12 9V15.68",
     :stroke inner-stroke,
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M17 10.74V13.94",
     :stroke inner-stroke,
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn setting [{:keys [fill inner-stroke]
                :or   {fill         "none"
                       inner-stroke "currentColor"}}]
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 25 24",
    :fill fill}
   [:path
    {:d
     "M2.5 12.88V11.12C2.5 10.08 3.35 9.22 4.4 9.22C6.21 9.22 6.95 7.94 6.04 6.37C5.52 5.47 5.83 4.3 6.74 3.78L8.47 2.79C9.26 2.32 10.28 2.6 10.75 3.39L10.86 3.58C11.76 5.15 13.24 5.15 14.15 3.58L14.26 3.39C14.73 2.6 15.75 2.32 16.54 2.79L18.27 3.78C19.18 4.3 19.49 5.47 18.97 6.37C18.06 7.94 18.8 9.22 20.61 9.22C21.65 9.22 22.51 10.07 22.51 11.12V12.88C22.51 13.92 21.66 14.78 20.61 14.78C18.8 14.78 18.06 16.06 18.97 17.63C19.49 18.54 19.18 19.7 18.27 20.22L16.54 21.21C15.75 21.68 14.73 21.4 14.26 20.61L14.15 20.42C13.25 18.85 11.77 18.85 10.86 20.42L10.75 20.61C10.28 21.4 9.26 21.68 8.47 21.21L6.74 20.22C6.3041 19.969 5.98558 19.5553 5.85435 19.0698C5.72311 18.5842 5.78988 18.0664 6.04 17.63C6.95 16.06 6.21 14.78 4.4 14.78C3.35 14.78 2.5 13.92 2.5 12.88V12.88Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M12.5 15C13.2956 15 14.0587 14.6839 14.6213 14.1213C15.1839 13.5587 15.5 12.7956 15.5 12C15.5 11.2044 15.1839 10.4413 14.6213 9.87868C14.0587 9.31607 13.2956 9 12.5 9C11.7044 9 10.9413 9.31607 10.3787 9.87868C9.81607 10.4413 9.5 11.2044 9.5 12C9.5 12.7956 9.81607 13.5587 10.3787 14.1213C10.9413 14.6839 11.7044 15 12.5 15V15Z",
     :stroke inner-stroke,
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn add-circle []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 31 31",
    :fill "none"}
   [:path
    {:d
     "M15.5 2.58334C8.38293 2.58334 2.58334 8.38293 2.58334 15.5C2.58334 22.6171 8.38293 28.4167 15.5 28.4167C22.6171 28.4167 28.4167 22.6171 28.4167 15.5C28.4167 8.38293 22.6171 2.58334 15.5 2.58334ZM20.6667 16.4688H16.4688V20.6667C16.4688 21.1963 16.0296 21.6354 15.5 21.6354C14.9704 21.6354 14.5313 21.1963 14.5313 20.6667V16.4688H10.3333C9.80376 16.4688 9.36459 16.0296 9.36459 15.5C9.36459 14.9704 9.80376 14.5313 10.3333 14.5313H14.5313V10.3333C14.5313 9.80376 14.9704 9.36459 15.5 9.36459C16.0296 9.36459 16.4688 9.80376 16.4688 10.3333V14.5313H20.6667C21.1963 14.5313 21.6354 14.9704 21.6354 15.5C21.6354 16.0296 21.1963 16.4688 20.6667 16.4688Z",
     :fill "currentColor"}]])

(defn call []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 20",
    :fill "none"}
   [:path
    {:d
     "M18.3083 15.275C18.3083 15.575 18.2417 15.8833 18.1 16.1833C17.9583 16.4833 17.775 16.7667 17.5333 17.0333C17.125 17.4833 16.675 17.8083 16.1667 18.0167C15.6667 18.225 15.125 18.3333 14.5417 18.3333C13.6917 18.3333 12.7833 18.1333 11.825 17.725C10.8667 17.3167 9.90832 16.7667 8.95832 16.075C7.99999 15.375 7.09166 14.6 6.22499 13.7417C5.36666 12.875 4.59166 11.9667 3.89999 11.0167C3.21666 10.0667 2.66666 9.11667 2.26666 8.175C1.86666 7.225 1.66666 6.31667 1.66666 5.45C1.66666 4.88333 1.76666 4.34167 1.96666 3.84167C2.16666 3.33333 2.48332 2.86667 2.92499 2.45C3.45832 1.925 4.04166 1.66667 4.65832 1.66667C4.89166 1.66667 5.12499 1.71667 5.33332 1.81667C5.54999 1.91667 5.74166 2.06667 5.89166 2.28333L7.82499 5.00833C7.97499 5.21667 8.08332 5.40833 8.15832 5.59167C8.23332 5.76667 8.27499 5.94167 8.27499 6.1C8.27499 6.3 8.21666 6.5 8.09999 6.69167C7.99166 6.88333 7.83332 7.08333 7.63332 7.28333L6.99999 7.94167C6.90832 8.03333 6.86666 8.14167 6.86666 8.275C6.86666 8.34167 6.87499 8.4 6.89166 8.46667C6.91666 8.53333 6.94166 8.58333 6.95832 8.63333C7.10832 8.90833 7.36666 9.26667 7.73332 9.7C8.10832 10.1333 8.50832 10.575 8.94166 11.0167C9.39166 11.4583 9.82499 11.8667 10.2667 12.2417C10.7 12.6083 11.0583 12.8583 11.3417 13.0083C11.3833 13.025 11.4333 13.05 11.4917 13.075C11.5583 13.1 11.625 13.1083 11.7 13.1083C11.8417 13.1083 11.95 13.0583 12.0417 12.9667L12.675 12.3417C12.8833 12.1333 13.0833 11.975 13.275 11.875C13.4667 11.7583 13.6583 11.7 13.8667 11.7C14.025 11.7 14.1917 11.7333 14.375 11.8083C14.5583 11.8833 14.75 11.9917 14.9583 12.1333L17.7167 14.0917C17.9333 14.2417 18.0833 14.4167 18.175 14.625C18.2583 14.8333 18.3083 15.0417 18.3083 15.275Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10}]])

(defn paper-clip []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill "none"}
   [:path
    {:d
     "M11.97 12V15.5C11.97 17.43 13.54 19 15.47 19C17.4 19 18.97 17.43 18.97 15.5V10C18.97 6.13 15.84 3 11.97 3C8.09997 3 4.96997 6.13 4.96997 10V16C4.96997 19.31 7.65997 22 10.97 22",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn send []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill "none"}
   [:path
    {:d
     "M7.39999 6.32003L15.89 3.49003C19.7 2.22003 21.77 4.30003 20.51 8.11003L17.68 16.6C15.78 22.31 12.66 22.31 10.76 16.6L9.91999 14.08L7.39999 13.24C1.68999 11.34 1.68999 8.23003 7.39999 6.32003Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M10.11 13.6501L13.69 10.0601",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn microphone []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill "none"}
   [:path
    {:d
     "M12 15.5C14.21 15.5 16 13.71 16 11.5V6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V11.5C8 13.71 9.79 15.5 12 15.5Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M4.3501 9.6499V11.3499C4.3501 15.5699 7.7801 18.9999 12.0001 18.9999C16.2201 18.9999 19.6501 15.5699 19.6501 11.3499V9.6499",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M10.6101 6.43012C11.5101 6.10012 12.4901 6.10012 13.3901 6.43012",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M11.2 8.55007C11.73 8.41007 12.28 8.41007 12.81 8.55007",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M12 19V22",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn dollar-circle []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 21",
    :fill "none"}
   [:path
    {:d
     "M7.22656 12.4415C7.22656 13.5165 8.05156 14.3832 9.07656 14.3832H11.1682C12.0599 14.3832 12.7849 13.6249 12.7849 12.6915C12.7849 11.6749 12.3432 11.3165 11.6849 11.0832L8.32656 9.91655C7.66823 9.68321 7.22656 9.32488 7.22656 8.30821C7.22656 7.37488 7.95156 6.61655 8.84323 6.61655H10.9349C11.9599 6.61655 12.7849 7.48321 12.7849 8.55821",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M10 5.5V15.5",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M9.99999 18.8333C14.6024 18.8333 18.3333 15.1024 18.3333 10.5C18.3333 5.89762 14.6024 2.16666 9.99999 2.16666C5.39762 2.16666 1.66666 5.89762 1.66666 10.5C1.66666 15.1024 5.39762 18.8333 9.99999 18.8333Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn notification []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 24",
    :fill "none"}
   [:g
    {:opacity 1}
    [:path
     {:d
      "M12.02 2.91C8.71003 2.91 6.02003 5.6 6.02003 8.91V11.8C6.02003 12.41 5.76003 13.34 5.45003 13.86L4.30003 15.77C3.59003 16.95 4.08003 18.26 5.38003 18.7C9.69003 20.14 14.34 20.14 18.65 18.7C19.86 18.3 20.39 16.87 19.73 15.77L18.58 13.86C18.28 13.34 18.02 12.41 18.02 11.8V8.91C18.02 5.61 15.32 2.91 12.02 2.91Z",
      :stroke "currentColor",
      :stroke-width 1.5,
      :stroke-miterlimit 10,
      :stroke-linecap "round"}]
    [:path
     {:d
      "M13.87 3.2C13.56 3.11 13.24 3.04 12.91 3C11.95 2.88 11.03 2.95 10.17 3.2C10.46 2.46 11.18 1.94 12.02 1.94C12.86 1.94 13.58 2.46 13.87 3.2Z",
      :stroke "currentColor",
      :stroke-width 1.5,
      :stroke-miterlimit 10,
      :stroke-linecap "round",
      :stroke-linejoin "round"}]
    [:path
     {:d
      "M15.02 19.06C15.02 20.71 13.67 22.06 12.02 22.06C11.2 22.06 10.44 21.72 9.90002 21.18C9.36002 20.64 9.02002 19.88 9.02002 19.06",
      :stroke "currentColor",
      :stroke-width 1.5,
      :stroke-miterlimit 10}]]])

(defn empty-wallet []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 21",
    :fill "none"}
   [:path
    {:d
     "M15.0333 11.7916C14.6833 12.1333 14.4833 12.625 14.5333 13.15C14.6083 14.05 15.4333 14.7083 16.3333 14.7083H17.9166V15.7C17.9166 17.425 16.5083 18.8333 14.7833 18.8333H5.21665C3.49165 18.8333 2.08331 17.425 2.08331 15.7V10.0917C2.08331 8.36665 3.49165 6.95831 5.21665 6.95831H14.7833C16.5083 6.95831 17.9166 8.36665 17.9166 10.0917V11.2917H16.2333C15.7666 11.2917 15.3416 11.475 15.0333 11.7916Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M2.08331 10.8416V7.03336C2.08331 6.04169 2.69165 5.15832 3.61665 4.80832L10.2333 2.30832C11.2666 1.91666 12.375 2.68335 12.375 3.79168V6.95834",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M18.799 12.1418V13.8585C18.799 14.3169 18.4323 14.6918 17.9657 14.7085H16.3323C15.4323 14.7085 14.6073 14.0502 14.5323 13.1502C14.4823 12.6252 14.6823 12.1335 15.0323 11.7918C15.3407 11.4752 15.7657 11.2918 16.2323 11.2918H17.9657C18.4323 11.3085 18.799 11.6835 18.799 12.1418Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M5.83331 10.5H11.6666",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn empty-wallet-change []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 21",
    :fill "none"}
   [:path
    {:d
     "M2.08334 11.5333V10.0917C2.08334 8.36665 3.49167 6.95831 5.21667 6.95831H14.7833C16.5083 6.95831 17.9167 8.36665 17.9167 10.0917V11.2917H16.2333C15.7667 11.2917 15.3417 11.475 15.0333 11.7916C14.6833 12.1333 14.4833 12.625 14.5333 13.15C14.6083 14.05 15.4333 14.7083 16.3333 14.7083H17.9167V15.7C17.9167 17.425 16.5083 18.8333 14.7833 18.8333H10.2167",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M2.08334 10.8416V7.03336C2.08334 6.04169 2.69167 5.15832 3.61667 4.80832L10.2333 2.30832C11.2667 1.91666 12.375 2.68335 12.375 3.79168V6.95834",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M18.799 12.1418V13.8585C18.799 14.3169 18.4323 14.6918 17.9657 14.7085H16.3324C15.4324 14.7085 14.6074 14.0502 14.5324 13.1502C14.4824 12.6252 14.6823 12.1335 15.0323 11.7918C15.3407 11.4752 15.7657 11.2918 16.2323 11.2918H17.9657C18.4323 11.3085 18.799 11.6835 18.799 12.1418Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M5.83334 10.5H11.6667",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M2.5 14.25H6.95C7.48333 14.25 7.91667 14.6833 7.91667 15.2166V16.2833",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M3.51667 13.2334L2.5 14.25L3.51667 15.2667",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M7.91667 18.65H3.46667C2.93334 18.65 2.5 18.2167 2.5 17.6833V16.6167",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M6.90103 19.6669L7.9177 18.6503L6.90103 17.6336",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn discount-shape []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 21",
    :fill "none"}
   [:path
    {:d
     "M3.32408 12.717L2.05742 11.4504C1.54076 10.9337 1.54076 10.0837 2.05742 9.56701L3.32408 8.30033C3.54075 8.08366 3.71575 7.65866 3.71575 7.35866V5.56697C3.71575 4.83364 4.31575 4.23366 5.04909 4.23366H6.84075C7.14075 4.23366 7.56575 4.05869 7.78242 3.84202L9.04908 2.57534C9.56574 2.05867 10.4158 2.05867 10.9324 2.57534L12.1991 3.84202C12.4158 4.05869 12.8407 4.23366 13.1407 4.23366H14.9324C15.6658 4.23366 16.2657 4.83364 16.2657 5.56697V7.35866C16.2657 7.65866 16.4407 8.08366 16.6574 8.30033L17.9241 9.56701C18.4408 10.0837 18.4408 10.9337 17.9241 11.4504L16.6574 12.717C16.4407 12.9337 16.2657 13.3587 16.2657 13.6587V15.4503C16.2657 16.1836 15.6658 16.7837 14.9324 16.7837H13.1407C12.8407 16.7837 12.4158 16.9587 12.1991 17.1754L10.9324 18.442C10.4158 18.9587 9.56574 18.9587 9.04908 18.442L7.78242 17.1754C7.56575 16.9587 7.14075 16.7837 6.84075 16.7837H5.04909C4.31575 16.7837 3.71575 16.1836 3.71575 15.4503V13.6587C3.71575 13.3504 3.54075 12.9254 3.32408 12.717Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M7.5 13L12.5 8",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M12.0788 12.5833H12.0863",
     :stroke "currentColor",
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M7.91209 8.41667H7.91957",
     :stroke "currentColor",
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn money-change []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 20",
    :fill "none"}
   [:path
    {:d
     "M1.66666 9.16668V7.50001C1.66666 4.58334 3.33332 3.33334 5.83332 3.33334H14.1667C16.6667 3.33334 18.3333 4.58334 18.3333 7.50001V12.5C18.3333 15.4167 16.6667 16.6667 14.1667 16.6667H9.99999",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M9.99999 12.0833C11.1506 12.0833 12.0833 11.1506 12.0833 9.99999C12.0833 8.8494 11.1506 7.91666 9.99999 7.91666C8.8494 7.91666 7.91666 8.8494 7.91666 9.99999C7.91666 11.1506 8.8494 12.0833 9.99999 12.0833Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M15.4167 7.91666V12.0833",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M1.66666 12.9167H6.11668C6.65001 12.9167 7.08332 13.35 7.08332 13.8833V14.95",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M2.6833 11.9L1.66666 12.9167L2.6833 13.9333",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M7.08332 17.3167H2.6333C2.09997 17.3167 1.66666 16.8833 1.66666 16.35V15.2834",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M6.06769 18.3336L7.08433 17.317L6.06769 16.3003",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn- calendar-default []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 20",
    :fill "none"}
   [:path
    {:d "M6.66669 1.66666V4.16666",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M13.3333 1.66666V4.16666",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M13.3333 2.91666C16.1083 3.06666 17.5 4.12499 17.5 8.04166V13.1917C17.5 16.625 16.6667 18.3417 12.5 18.3417H7.5C3.33333 18.3417 2.5 16.625 2.5 13.1917V8.04166C2.5 4.12499 3.89167 3.07499 6.66667 2.91666H13.3333Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M17.2916 14.6667H2.70831",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M10 6.875C8.97502 6.875 8.10835 7.43333 8.10835 8.51667C8.10835 9.03333 8.35002 9.425 8.71669 9.675C8.20835 9.975 7.91669 10.4583 7.91669 11.025C7.91669 12.0583 8.70835 12.7 10 12.7C11.2834 12.7 12.0834 12.0583 12.0834 11.025C12.0834 10.4583 11.7917 9.96667 11.275 9.675C11.65 9.41667 11.8834 9.03333 11.8834 8.51667C11.8834 7.43333 11.025 6.875 10 6.875ZM10 9.24167C9.56669 9.24167 9.25002 8.98333 9.25002 8.575C9.25002 8.15833 9.56669 7.91667 10 7.91667C10.4334 7.91667 10.75 8.15833 10.75 8.575C10.75 8.98333 10.4334 9.24167 10 9.24167ZM10 11.6667C9.45002 11.6667 9.05002 11.3917 9.05002 10.8917C9.05002 10.3917 9.45002 10.125 10 10.125C10.55 10.125 10.95 10.4 10.95 10.8917C10.95 11.3917 10.55 11.6667 10 11.6667Z",
     :fill "currentColor"}]])

(defn- calendar-a [{:keys [fill inner-stroke]
                    :or   {fill         "none"
                           inner-stroke "currentColor"}}]
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 24,
    :height 24,
    :view-box "0 0 24 24",
    :fill fill}
   [:path
    {:d "M8 2V5",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M16 2V5",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M3.5 9.08997H20.5",
     :stroke inner-stroke,
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M11.9955 13.7H12.0045",
     :stroke inner-stroke,
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M8.29431 13.7H8.30329",
     :stroke inner-stroke,
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M8.29431 16.7H8.30329",
     :stroke inner-stroke,
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn- calendar-variants []
  {:default calendar-default
   :a       calendar-a})

(defn calendar [{:keys [variant]
                 :or   {variant :default}}]
  (get (calendar-variants) variant))

(defn money-send []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 20",
    :fill "none"}
   [:path
    {:d
     "M6.59723 9.54862C6.59723 10.2222 7.11807 10.7639 7.75696 10.7639H9.0625C9.61805 10.7639 10.0695 10.2917 10.0695 9.7014C10.0695 9.06945 9.79168 8.84029 9.38196 8.69445L7.29167 7.96528C6.88195 7.81945 6.60418 7.59723 6.60418 6.95834C6.60418 6.37501 7.05556 5.89584 7.61111 5.89584H8.91667C9.55556 5.89584 10.0764 6.43751 10.0764 7.11112",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M8.33334 5.20834V11.4583",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M15.2778 8.33333C15.2778 12.1667 12.1667 15.2778 8.33333 15.2778C4.5 15.2778 1.38889 12.1667 1.38889 8.33333C1.38889 4.5 4.5 1.38889 8.33333 1.38889",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M15.2778 4.16666V1.38889H12.5",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M11.8055 4.86111L15.2778 1.38889",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn ticket []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 24",
    :fill "none"}
   [:path
    {:d
     "M16.25 10.4167C16.25 9.26668 17.1834 8.33334 18.3334 8.33334V7.50001C18.3334 4.16668 17.5 3.33334 14.1667 3.33334H5.83335C2.50002 3.33334 1.66669 4.16668 1.66669 7.50001V7.91668C2.81669 7.91668 3.75002 8.85001 3.75002 10C3.75002 11.15 2.81669 12.0833 1.66669 12.0833V12.5C1.66669 15.8333 2.50002 16.6667 5.83335 16.6667H14.1667C17.5 16.6667 18.3334 15.8333 18.3334 12.5C17.1834 12.5 16.25 11.5667 16.25 10.4167Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M8.33331 3.33334L8.33331 16.6667",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round",
     :stroke-dasharray "5 5"}]])

(defn profile-tick []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 24",
    :fill "none"}
   [:path
    {:d "M12.0333 15.875L13.3 17.1417L15.8333 14.6083",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M10.1333 9.05834C10.05 9.05 9.94996 9.05 9.85829 9.05834C7.87496 8.99167 6.29996 7.36667 6.29996 5.36667C6.29162 3.32501 7.94996 1.66667 9.99162 1.66667C12.0333 1.66667 13.6916 3.32501 13.6916 5.36667C13.6916 7.36667 12.1083 8.99167 10.1333 9.05834Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M9.99164 18.175C8.47497 18.175 6.96664 17.7917 5.81664 17.025C3.79997 15.675 3.79997 13.475 5.81664 12.1333C8.1083 10.6 11.8666 10.6 14.1583 12.1333",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn briefcase []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 20",
    :fill "none"}
   [:path
    {:d
     "M6.66666 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583L18.0833 8.69167C18.3083 6.65833 17.725 5 14.1667 5H5.83333C2.275 5 1.69166 6.65833 1.91666 8.69167L2.54166 15.3583C2.71666 16.9917 3.31666 18.3333 6.66666 18.3333Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M6.66669 5.00001V4.33334C6.66669 2.85834 6.66669 1.66667 9.33335 1.66667H10.6667C13.3334 1.66667 13.3334 2.85834 13.3334 4.33334V5.00001",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M11.6666 10.8333V11.6667C11.6666 11.675 11.6666 11.675 11.6666 11.6833C11.6666 12.5917 11.6583 13.3333 9.99998 13.3333C8.34998 13.3333 8.33331 12.6 8.33331 11.6917V10.8333C8.33331 10 8.33331 10 9.16665 10H10.8333C11.6666 10 11.6666 10 11.6666 10.8333Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M18.0417 9.16667C16.1167 10.5667 13.9167 11.4 11.6667 11.6833",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M2.18335 9.39166C4.05835 10.675 6.17502 11.45 8.33335 11.6917",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn data []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 20",
    :fill "none"}
   [:path
    {:d
     "M16.6667 11.6667C17.5871 11.6667 18.3333 10.9205 18.3333 9.99999C18.3333 9.07952 17.5871 8.33333 16.6667 8.33333C15.7462 8.33333 15 9.07952 15 9.99999C15 10.9205 15.7462 11.6667 16.6667 11.6667Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M16.6667 5.00001C17.5871 5.00001 18.3333 4.25381 18.3333 3.33334C18.3333 2.41286 17.5871 1.66667 16.6667 1.66667C15.7462 1.66667 15 2.41286 15 3.33334C15 4.25381 15.7462 5.00001 16.6667 5.00001Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M16.6667 18.3333C17.5871 18.3333 18.3333 17.5871 18.3333 16.6667C18.3333 15.7462 17.5871 15 16.6667 15C15.7462 15 15 15.7462 15 16.6667C15 17.5871 15.7462 18.3333 16.6667 18.3333Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M3.33332 11.6667C4.2538 11.6667 4.99999 10.9205 4.99999 9.99999C4.99999 9.07952 4.2538 8.33333 3.33332 8.33333C2.41285 8.33333 1.66666 9.07952 1.66666 9.99999C1.66666 10.9205 2.41285 11.6667 3.33332 11.6667Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M5 10H15",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M15 3.33333H11.6667C9.99999 3.33333 9.16666 4.16666 9.16666 5.83333V14.1667C9.16666 15.8333 9.99999 16.6667 11.6667 16.6667H15",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn message-notification []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 20",
    :fill "none"}
   [:path
    {:d
     "M18.3334 8.33334V10.8333C18.3334 14.1667 16.6667 15.8333 13.3334 15.8333H12.9167C12.6584 15.8333 12.4084 15.9583 12.25 16.1667L11 17.8333C10.45 18.5667 9.55002 18.5667 9.00002 17.8333L7.75002 16.1667C7.61669 15.9833 7.30835 15.8333 7.08335 15.8333H6.66669C3.33335 15.8333 1.66669 15 1.66669 10.8333V6.66667C1.66669 3.33334 3.33335 1.66667 6.66669 1.66667H11.6667",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M16.25 5.83334C17.4006 5.83334 18.3334 4.9006 18.3334 3.75001C18.3334 2.59941 17.4006 1.66667 16.25 1.66667C15.0994 1.66667 14.1667 2.59941 14.1667 3.75001C14.1667 4.9006 15.0994 5.83334 16.25 5.83334Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M13.3304 9.16667H13.3378",
     :stroke "currentColor",
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M9.99626 9.16667H10.0037",
     :stroke "currentColor",
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d "M6.66209 9.16667H6.66957",
     :stroke "currentColor",
     :stroke-width 2,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn profile-circle []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 21",
    :fill "none"}
   [:path
    {:d
     "M10.1 11.15C10.0417 11.1417 9.96666 11.1417 9.9 11.15C8.43333 11.1 7.26666 9.9 7.26666 8.425C7.26666 6.91667 8.48333 5.69167 10 5.69167C11.5083 5.69167 12.7333 6.91667 12.7333 8.425C12.725 9.9 11.5667 11.1 10.1 11.15Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M15.6167 16.65C14.1333 18.0083 12.1667 18.8333 10 18.8333C7.83333 18.8333 5.86666 18.0083 4.38333 16.65C4.46666 15.8667 4.96666 15.1 5.85833 14.5C8.14166 12.9833 11.875 12.9833 14.1417 14.5C15.0333 15.1 15.5333 15.8667 15.6167 16.65Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M9.99999 18.8333C14.6024 18.8333 18.3333 15.1024 18.3333 10.5C18.3333 5.89762 14.6024 2.16666 9.99999 2.16666C5.39762 2.16666 1.66666 5.89762 1.66666 10.5C1.66666 15.1024 5.39762 18.8333 9.99999 18.8333Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn sms []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 20",
    :fill "none"}
   [:path
    {:d
     "M14.1667 17.0833H5.83335C3.33335 17.0833 1.66669 15.8333 1.66669 12.9167V7.08333C1.66669 4.16667 3.33335 2.91667 5.83335 2.91667H14.1667C16.6667 2.91667 18.3334 4.16667 18.3334 7.08333V12.9167C18.3334 15.8333 16.6667 17.0833 14.1667 17.0833Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M14.1666 7.5L11.5583 9.58333C10.7 10.2667 9.29164 10.2667 8.43331 9.58333L5.83331 7.5",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-miterlimit 10,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn location []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 21",
    :fill "none"}
   [:path
    {:d
     "M9.99999 11.6917C11.4359 11.6917 12.6 10.5276 12.6 9.09167C12.6 7.65573 11.4359 6.49167 9.99999 6.49167C8.56405 6.49167 7.39999 7.65573 7.39999 9.09167C7.39999 10.5276 8.56405 11.6917 9.99999 11.6917Z",
     :stroke "currentColor",
     :stroke-width 1.5}]
   [:path
    {:d
     "M3.01666 7.575C4.65832 0.358334 15.35 0.366667 16.9833 7.58333C17.9417 11.8167 15.3083 15.4 13 17.6167C11.325 19.2333 8.67499 19.2333 6.99166 17.6167C4.69166 15.4 2.05832 11.8083 3.01666 7.575Z",
     :stroke "currentColor",
     :stroke-width 1.5}]])

(defn loading-spinner
  "Loading spinner svg-icon"
  [{:keys [width height class]}]
  [:svg
   {:class class
    :width (or width "64px")
    :height (or height "64px")
    :view-box "0 0 64 64"
    :fill "none"
    :xmlns "http://www.w3.org/2000/svg"}
   [:path
    {:fill-rule "evenodd"
     :clip-rule "evenodd"
     :d
     "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32Zm0-5.333c14.728 0 26.667-11.94 26.667-26.667 0-14.728-11.94-26.667-26.667-26.667C17.272 5.333 5.333 17.273 5.333 32c0 14.728 11.94 26.667 26.667 26.667Z"
     :fill "url(#a)"}]
   [:path
    {:fill-rule "evenodd"
     :clip-rule "evenodd"
     :d
     "M60.751 25.602a2.667 2.667 0 0 1 2.986 2.303C63.912 29.263 64 30.631 64 32a2.667 2.667 0 1 1-5.333 0c0-1.141-.074-2.28-.22-3.412a2.667 2.667 0 0 1 2.304-2.986Z"
     :fill "#15B79E"}]
   [:defs
    [:radialGradient#a
     {:cx 0
      :cy 0
      :r 1
      :gradient-units "userSpaceOnUse"
      :gradient-transform "matrix(64 0 0 64 64 64)"}
     [:stop {:stop-color "#2ED3B7" :stop-opacity 0}]
     [:stop {:offset 0 :stop-color "#12B76A", :stop-opacity 0}]
     [:stop {:offset 1 :stop-color "#2ED3B7"}]]]])

(defn clock [{:keys [height width]
              :or   {height 24
                     width  24}}]
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width width,
    :height height,
    :view-box "0 0 24 24",
    :fill "none"}
   [:path
    {:d
     "M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]
   [:path
    {:d
     "M15.71 15.18L12.61 13.33C12.07 13.01 11.63 12.24 11.63 11.61V7.51001",
     :stroke "currentColor",
     :stroke-width 1.5,
     :stroke-linecap "round",
     :stroke-linejoin "round"}]])

(defn youtube
  []
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width    24,
    :height   24,
    :view-box "0 0 24 24",
    :fill     "none"}
   [:path
    {:fill-rule "evenodd",
     :clip-rule "evenodd",
     :d
     "M12 4V6h-0.267a121.99 121.99 0 0 0 -3.026 0.051 61.965 61.965 0 0 0 -2.571 0.123c-0.807 0.058 -1.398 0.132 -1.689 0.209a1.527 1.527 0 0 0 -1.05 1.068A25.362 25.362 0 0 0 3 12.04v0.011a25.215 25.215 0 0 0 0.392 4.607 1.527 1.527 0 0 0 1.05 1.013c0.289 0.076 0.882 0.15 1.695 0.21 0.784 0.057 1.696 0.096 2.57 0.121a124.033 124.033 0 0 0 3.026 0.051h0.534a125.145 125.145 0 0 0 3.027 -0.051c0.873 -0.026 1.785 -0.065 2.571 -0.121 0.807 -0.06 1.398 -0.132 1.688 -0.21a1.525 1.525 0 0 0 1.051 -1.067A25.38 25.38 0 0 0 21 12.048v-0.009a25.359 25.359 0 0 0 -0.396 -4.625 1.527 1.527 0 0 0 -1.041 -1.065c-0.3 -0.072 -0.895 -0.138 -1.692 -0.191a68.242 68.242 0 0 0 -2.575 -0.112 135.666 135.666 0 0 0 -3.027 -0.045L12.069 6H12V3.999h0.074l0.203 0.002a135.225 135.225 0 0 1 3.075 0.048 72 72 0 0 1 2.652 0.114c0.8 0.054 1.566 0.129 2.052 0.247a3.528 3.528 0 0 1 2.511 2.612c0.3 1.659 0.444 3.34 0.435 5.025a27.369 27.369 0 0 1 -0.45 5.013 3.528 3.528 0 0 1 -2.46 2.538l-0.015 0.005c-0.495 0.132 -1.268 0.214 -2.066 0.273a65.91 65.91 0 0 1 -2.658 0.126 125.748 125.748 0 0 1 -3.075 0.051l-0.204 0.002h-0.35a144.248 144.248 0 0 1 -3.075 -0.053 64.02 64.02 0 0 1 -2.658 -0.126c-0.798 -0.06 -1.572 -0.141 -2.067 -0.273l-0.005 -0.002a3.525 3.525 0 0 1 -2.484 -2.534 27.363 27.363 0 0 1 -0.435 -5.024 27.363 27.363 0 0 1 0.45 -5.05 3.526 3.526 0 0 1 2.46 -2.538l0.015 -0.003c0.494 -0.132 1.268 -0.214 2.066 -0.273 0.827 -0.06 1.77 -0.101 2.656 -0.126a125.64 125.64 0 0 1 3.28 -0.053H12Zm-0.504 3.933 0.028 0.018 3.942 2.535 0.027 0.015c0.15 0.098 0.315 0.204 0.447 0.306 0.14 0.109 0.36 0.3 0.489 0.609a1.5 1.5 0 0 1 0 1.167 1.533 1.533 0 0 1 -0.489 0.608 6.296 6.296 0 0 1 -0.474 0.323L11.524 16.05l-0.03 0.018a6.84 6.84 0 0 1 -0.522 0.317c-0.165 0.086 -0.461 0.223 -0.83 0.197a1.5 1.5 0 0 1 -1.093 -0.597 1.548 1.548 0 0 1 -0.282 -0.802 7.117 7.117 0 0 1 -0.017 -0.612V9.432c0 -0.21 0 -0.429 0.015 -0.612 0.018 -0.183 0.063 -0.509 0.285 -0.804a1.5 1.5 0 0 1 1.092 -0.597c0.369 -0.026 0.666 0.112 0.83 0.197 0.162 0.086 0.348 0.204 0.523 0.318Zm-0.746 1.897v4.337L14.124 12 10.75 9.831Z",
     :fill      "currentColor"}]])

(defn bp-original
  [{:keys [width height]}]
  [:svg
   {:xmlns    "http://www.w3.org/2000/svg",
    :width    (or width 24)
    :height   (or height 19)
    :view-box "0 0 24 19",
    :fill     "none"}
   [:path
    {:d
     "M17.5419 10.7748L17.54 10.7783C17.5419 10.7765 17.5419 10.7748 17.5419 10.7748C16.9896 10.8013 16.4126 10.8243 15.8146 10.8438C15.5822 10.8509 15.388 10.8898 15.1766 10.9766C14.9652 11.0633 14.8471 11.1642 14.6986 11.297C13.9977 11.9343 13.0417 12.3274 11.9847 12.3291C10.9277 12.3256 9.97171 11.9326 9.27087 11.297C9.12423 11.1625 8.97568 11.0492 8.79285 10.9766C8.61193 10.904 8.3891 10.8509 8.15486 10.8438C7.55686 10.8243 6.9798 10.8013 6.42751 10.7748C6.42751 10.7765 6.42942 10.7783 6.42942 10.7783L6.42751 10.7748L6.00472 10.7517V10.8509C6.30943 10.966 6.56844 11.1642 6.75127 11.4121C6.75317 11.4121 6.75508 11.4121 6.75508 11.4121V11.4103C7.77587 13.117 9.73175 14.2712 11.979 14.2783C11.9809 14.2783 11.9828 14.2783 11.9847 14.2783C11.9866 14.2783 11.9885 14.2783 11.9904 14.2783C14.2377 14.273 16.1936 13.117 17.2144 11.4103V11.4121C17.2144 11.4121 17.2163 11.4121 17.2182 11.4121C17.401 11.1625 17.66 10.966 17.9647 10.8509V10.7517L17.5419 10.7748Z",
     :fill "currentColor"}]
   [:path
    {:d
     "M19.0674 8.32454C18.001 8.11918 17.7743 7.20212 17.7743 7.20212C17.0544 4.87762 14.7481 3.17629 12.0152 3.17629C12.0114 3.17629 12.0057 3.17629 12.0019 3.17629C11.9981 3.17629 11.9924 3.17629 11.9886 3.17629C9.25567 3.17629 6.95128 4.87762 6.22949 7.20212C6.22949 7.20212 6.00286 8.11918 4.93636 8.32454C1.94445 8.52636 0 8.85565 0 9.22566C0 9.64524 2.50436 10.0117 6.19902 10.2011C6.20092 10.21 8.46532 10.3003 8.46151 10.2897C9.57562 10.3215 10.7602 10.3392 11.9867 10.3392C11.9905 10.3392 11.9962 10.3392 12 10.3392C12.0038 10.3392 12.0095 10.3392 12.0133 10.3392C13.2398 10.3392 14.4244 10.3215 15.5385 10.2897C15.5347 10.2985 17.7972 10.21 17.801 10.2011C21.4975 10.0117 24 9.64524 24 9.22566C24.0019 8.85565 22.0575 8.52636 19.0674 8.32454ZM15.6623 8.56177C15.4318 8.87336 15.1176 8.93001 15.0033 8.94948C14.0263 9.10173 13.0227 9.1814 12 9.18317C10.9773 9.18317 9.97365 9.1035 8.99667 8.94948C8.8824 8.93001 8.56816 8.87336 8.33772 8.56177C8.10728 8.25018 8.20441 7.87486 8.21774 7.83061C8.65577 6.27445 10.1755 5.12724 11.9867 5.12724C11.9905 5.12724 11.9962 5.12724 12 5.12724C12.0038 5.12724 12.0095 5.12724 12.0133 5.12724C13.8226 5.12724 15.3442 6.27445 15.7823 7.83061C15.7956 7.87309 15.8927 8.25018 15.6623 8.56177Z",
     :fill "currentColor"}]
   [:path
    {:d
     "M12.2838 0.605703C12.1295 0.488858 11.9124 0.481777 11.7486 0.587999L0.409462 8.27144L11.7677 0.0781309C11.92 -0.024551 12.1276 -0.0263214 12.2819 0.0745901C12.2819 0.0745901 23.8343 8.23072 23.8648 8.25373C23.9219 8.29799 23.9238 8.37589 23.8934 8.42192C23.8781 8.44316 23.8305 8.49096 23.7543 8.4768C23.2363 8.32455 22.7659 8.24134 22.564 8.20416C22.3926 8.17406 22.3603 8.15282 22.2384 8.0643C22.1165 7.97578 12.2838 0.605703 12.2838 0.605703Z",
     :fill "currentColor"}]
   [:path
    {:d
     "M23.781 8.47857C23.8557 8.47857 23.9162 8.4223 23.9162 8.35288C23.9162 8.28346 23.8557 8.22718 23.781 8.22718C23.7063 8.22718 23.6458 8.28346 23.6458 8.35288C23.6458 8.4223 23.7063 8.47857 23.781 8.47857Z",
     :fill "currentColor"}]
   [:path
    {:d
     "M12.3142 17.5783C12.1523 17.6845 11.9333 17.6775 11.7791 17.5606C11.7791 17.5606 2.19393 10.6951 2.07394 10.6083C1.95206 10.5216 1.91968 10.5003 1.74828 10.4685C1.56736 10.4366 0.782722 10.2613 0.586563 10.2171C0.573231 10.2118 0.5599 10.2082 0.544665 10.2082C0.540856 10.2082 0.537047 10.2082 0.535142 10.2082C0.462773 10.2082 0.403735 10.2631 0.403735 10.3304C0.403735 10.364 0.41897 10.3941 0.441824 10.4171L0.445633 10.4207C0.453251 10.4277 0.460868 10.4331 0.470391 10.4366L11.781 18.0581C11.9352 18.159 12.1428 18.159 12.2952 18.0545L23.4077 10.3994L12.3142 17.5783Z",
     :fill "currentColor"}]])

(defn- square-play
  []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 20 21",
    :fill "none"}
   [:g
    [:path
     {:d
      "M7.937 15.924a.762.762 0 0 1-.844.03c-.284-.159-.426-.405-.426-.739V6.59c0-.333.142-.58.426-.74a.763.763 0 0 1 .844.032l6.792 4.313a.8.8 0 0 1 .375.708.803.803 0 0 1-.375.708l-6.792 4.313Z",
      :fill "currentColor"}]]])

(defn- solid-play
  [{:keys [width height]}]
  [:svg
   {:width (or width "24")
    :height (or height "24")
    :view-box "0 0 24 24"
    :fill "none"
    :xmlns "http://www.w3.org/2000/svg"}
   [:path
    {:d
     "M9.525 18.025c-.333.217-.67.23-1.013.037-.341-.191-.512-.487-.512-.887V6.825c0-.4.17-.696.512-.888.342-.191.68-.179 1.013.038l8.15 5.175c.3.2.45.483.45.85s-.15.65-.45.85l-8.15 5.175Z",
     :fill "currentColor"}]])

(defn- circle-play
  []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width 25,
    :height 25,
    :view-box "0 0 24 24",
    :fill "none"}
   [:g
    {:filter "url(#filter0_b_9684_86152)"}
    [:rect
     {:width 24, :height 24, :rx 12, :fill "currentColor", :fill-opacity 0.64}]
    [:path
     {:d
      "M16.875 11.371c.5.28.5.978 0 1.258l-6.75 3.773c-.5.28-1.125-.07-1.125-.63V8.228c0-.559.625-.908 1.125-.629l6.75 3.773z",
      :fill "#fff"}]]
   [:defs
    [:filter
     {:x (- 16),
      :y (- 16),
      :width 56,
      :height 56,
      :filter-units "userSpaceOnUse",
      :color-interpolation-filters "sRGB"}
     [:fe-flood {:flood-opacity 0, :result "BackgroundImageFix"}]
     [:fe-gaussian-blur {:in "BackgroundImageFix", :std-deviation 8}]
     [:fe-composite
      {:in-2 "SourceAlpha",
       :operator "in",
       :result "effect1_backgroundBlur_9684_86152"}]
     [:fe-blend
      {:in "SourceGraphic",
       :in-2 "effect1_backgroundBlur_9684_86152",
       :result "shape"}]]]])

(defn- play-variants
  []
  {:default circle-play
   :solid   solid-play
   :square  square-play})

(defn play
  [{:keys [variant] :as props}]
  (let [icon (get (play-variants) (or variant :default))]
    [icon props]))

(defn thumb-up
  []
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :width "25"
    :height "25",
    :view-box "-3 -1 25 25",
    :fill "none"}
   [:path
    {:d
     "M15 18.403H6.666V7.569L12.5 1.736l1.041 1.042a1.1 1.1 0 0 1 .24.396c.063.166.094.326.094.479v.291l-.917 3.625H17.5c.444 0 .833.167 1.166.5.334.334.5.723.5 1.167v1.667a1.68 1.68 0 0 1-.125.625l-2.5 5.875a1.683 1.683 0 0 1-.625.708 1.628 1.628 0 0 1-.916.292ZM5 7.569v10.834H1.667V7.569H5Z",
     :fill "currentColor"}]])

(defn bp-logo
  [props]
  (let [fill   (-> props :fill (or "currentColor"))
        height (-> props :height (or "86px"))
        width  (-> props :width (or "100px"))]
    [:svg
     {:width width,
      :height height,
      :view-box "0 0 100 86",
      :fill "none",
      :xmlns "http://www.w3.org/2000/svg"}
     [:path
      {:d
       "M71.881 51.473v0.019c-2.262 0.127 -4.622 0.235 -7.081 0.327a6.289 6.289 0 0 0 -2.611 0.63c-0.862 0.405 -1.351 0.886 -1.957 1.524 -2.962 3.151 -6.957 4.919 -11.116 4.919 -4.162 0 -8.154 -1.768 -11.116 -4.919a6.581 6.581 0 0 0 -1.973 -1.524 6.781 6.781 0 0 0 -2.611 -0.63c-2.451 -0.089 -4.814 -0.2 -7.078 -0.327v0.022l-1.732 -0.108v0.473c1.243 0.549 2.308 1.478 3.065 2.676h0.014a25.689 25.689 0 0 0 8.984 9.957 23.205 23.205 0 0 0 12.422 3.681h0.043a23.197 23.197 0 0 0 12.422 -3.678 25.684 25.684 0 0 0 8.984 -9.962h0.014c0.757 -1.195 1.824 -2.124 3.065 -2.673v-0.473l-1.735 0.108Z",
       :fill fill}]
     [:path
      {:d
       "M78.127 39.819c-4.378 -0.973 -5.3 -5.338 -5.3 -5.338 -1.478 -5.522 -4.581 -10.373 -8.838 -13.827 -4.254 -3.454 -9.432 -5.324 -14.757 -5.324h-0.116c-5.324 0 -10.505 1.87 -14.762 5.324 -4.257 3.454 -7.357 8.305 -8.835 13.827 0 0 -0.93 4.362 -5.297 5.338C7.962 40.784 0 42.343 0 44.108c0 1.997 10.259 3.738 25.405 4.641 0 0.046 9.286 0.473 9.265 0.424 4.568 0.151 9.414 0.238 14.449 0.238h0.114c5.035 0 9.878 -0.081 14.446 -0.238 -0.019 0.043 9.257 -0.378 9.27 -0.424 15.143 -0.903 25.403 -2.643 25.403 -4.641 -0.005 -1.762 -7.973 -3.324 -20.224 -4.289Zm-13.946 1.127a4.162 4.162 0 0 1 -1.17 1.227 3.824 3.824 0 0 1 -1.527 0.622 68.941 68.941 0 0 1 -24.619 0 3.827 3.827 0 0 1 -1.527 -0.622 4.165 4.165 0 0 1 -1.173 -1.227c-0.943 -1.481 -0.541 -3.27 -0.492 -3.478 0.895 -3.684 2.897 -6.946 5.692 -9.27a15.227 15.227 0 0 1 9.751 -3.589h0.116a15.241 15.241 0 0 1 9.749 3.592c2.795 2.324 4.797 5.584 5.695 9.268 0.043 0.208 0.449 2 -0.495 3.486v-0.008Z",
       :fill fill}]
     [:path
      {:d
       "M50.335 3.103a1.724 1.724 0 0 0 -2.189 -0.081L1.678 39.573 48.219 0.597a1.722 1.722 0 0 1 1.049 -0.373c0.378 -0.003 0.746 0.122 1.054 0.357 0 0 47.335 38.797 47.465 38.908a0.678 0.678 0 0 1 0.119 0.8 0.559 0.559 0 0 1 -0.249 0.222 0.514 0.514 0 0 1 -0.324 0.032 40.519 40.519 0 0 0 -4.873 -1.292 2.286 2.286 0 0 1 -1.332 -0.659c-0.492 -0.416 -40.792 -35.486 -40.792 -35.486Z",
       :fill fill}]
     [:path
      {:d
       "M50.459 83.841a1.722 1.722 0 0 1 -2.189 -0.081L8.5 50.689a2.292 2.292 0 0 0 -1.332 -0.662 184.632 184.632 0 0 1 -4.759 -1.2 0.514 0.514 0 0 0 -0.168 -0.046H2.195a0.508 0.508 0 0 0 -0.297 0.1 0.57 0.57 0 0 0 -0.197 0.259 0.622 0.622 0 0 0 0.119 0.63l0.019 0.016c0.027 0.027 0.062 0.054 0.1 0.078l46.343 36.265c0.311 0.235 0.678 0.359 1.054 0.357a1.73 1.73 0 0 0 1.054 -0.37l45.527 -36.416 -45.459 34.141Z",
       :fill fill}]]))

(defn bp-name [props]
  (let [fill   (-> props :fill (or "currentColor"))
        height (-> props :height (or "34px"))
        width  (-> props :width (or "100px"))]
    [:svg
     {:height height,
      :width width,
      :fill "none",
      :xmlns "http://www.w3.org/2000/svg",
      :view-box "42.71 0 100 34"}
     [:path
      {:d
       "M53.3024 9.85011C53.3024 12.1278 51.7013 13.4379 48.5889 13.4379H42.7148V0.152952H48.2374C51.072 0.152952 52.6513 1.44302 52.6513 3.58784C52.6513 5.03083 51.9653 6.03505 50.9983 6.54897C52.3873 6.96587 53.3024 8.08548 53.3024 9.85011ZM44.4747 1.68947V5.94066H48.0803C49.8742 5.94066 50.8947 5.21958 50.8947 3.81504C50.8947 2.41051 49.8726 1.69297 48.0803 1.69297L44.4747 1.68947ZM51.5272 9.69891C51.5272 8.16152 50.4743 7.47803 48.5201 7.47803H44.4747V11.9005H48.5201C50.4703 11.9005 51.5256 11.2363 51.5256 9.69891H51.5272Z",
       :fill fill}]
     [:path
      {:d
       "M70.3335 12.7929L68.1006 9.36155C67.8577 9.38078 67.5904 9.39911 67.3272 9.39911H64.2845V13.4423H62.5254V0.157347H67.3272C70.5278 0.157347 72.4618 1.90537 72.4618 4.7896C72.4618 6.84003 71.477 8.31973 69.7536 8.98485L72.6732 13.4423H71.4916C71.2645 13.4421 71.0407 13.383 70.8391 13.27C70.6376 13.157 70.4642 12.9934 70.3335 12.7929ZM70.7036 4.78695C70.7036 2.88948 69.5252 1.80747 67.2738 1.80747H64.2845V7.78569H67.2745C69.5252 7.78132 70.7036 6.68095 70.7036 4.7826V4.78695Z",
       :fill fill}]
     [:path
      {:d
       "M90.4445 10.1158H83.9014L82.5473 13.437H80.7364L85.7204 1.55926C85.8966 1.13919 86.1813 0.78287 86.5405 0.533113C86.8996 0.283356 87.3179 0.150738 87.7451 0.151203H88.0537L93.6468 13.4362H92.6546C92.4005 13.4362 92.1518 13.3564 91.9389 13.2065C91.7261 13.0566 91.5583 12.843 91.456 12.5919L90.4445 10.1158ZM89.8282 8.59765L87.1726 2.08802L84.5169 8.59765H89.8282Z",
       :fill fill}]
     [:path
      {:d
       "M122.405 0.152099H123.164V12.0316C123.164 12.2163 123.13 12.3991 123.065 12.5697C122.999 12.7404 122.904 12.8954 122.783 13.0259C122.662 13.1565 122.518 13.2601 122.36 13.3308C122.202 13.4015 122.033 13.4379 121.861 13.4379H121.405V1.23061C121.405 1.08895 121.431 0.948668 121.481 0.817763C121.532 0.686858 121.605 0.567906 121.698 0.467732C121.791 0.367559 121.901 0.288112 122.022 0.233952C122.144 0.179791 122.274 0.151984 122.405 0.152099Z",
       :fill fill}]
     [:path
      {:d
       "M133.576 0.152098C134.042 0.152098 134.489 0.351965 134.819 0.707786C135.149 1.06361 135.334 1.54625 135.335 2.04957V11.786H142C142 12.224 141.839 12.644 141.552 12.9538C141.265 13.2635 140.876 13.4377 140.47 13.4379H133.576V0.152098Z",
       :fill fill}]
     [:path
      {:d
       "M102.042 11.9189C102.116 11.7482 102.221 11.595 102.351 11.4683C102.48 11.3417 102.631 11.244 102.796 11.1809C102.961 11.1178 103.135 11.0906 103.31 11.1009C103.484 11.1111 103.655 11.1587 103.812 11.2407C104.73 11.7212 105.736 11.9727 106.756 11.9766C108.883 11.9766 109.797 11.0842 109.797 9.92616C109.797 6.68096 102.341 8.7305 102.341 3.79584C102.341 1.74629 103.818 0 107.054 0C108.496 0 109.991 0.417773 111.011 1.17641L110.431 2.69548C109.422 1.99876 108.252 1.62365 107.054 1.61342C104.962 1.61342 104.064 2.5626 104.064 3.71979C104.064 6.96586 111.521 4.93466 111.521 9.81251C111.521 11.8437 110.009 13.5891 106.756 13.5891C104.873 13.5891 103.027 12.9065 102.042 11.9189Z",
       :fill fill}]
     [:path
      {:d
       "M54.2654 23.3169C54.2654 26.3916 52.0844 28.3276 48.6545 28.3276H46.8785V30.4593C46.8785 30.7606 46.7675 31.0496 46.5701 31.2627C46.3726 31.4758 46.1048 31.5955 45.8256 31.5955H42.7246V18.3105H48.6513C52.0844 18.3061 54.2654 20.2421 54.2654 23.3169ZM50.0791 23.3169C50.0791 22.3493 49.534 21.7611 48.3913 21.7611H46.8785V24.8735H48.3913C49.5381 24.8735 50.0791 24.2853 50.0791 23.3169Z",
       :fill fill}]
     [:path
      {:d
       "M128.097 24.9495C128.097 20.929 131.034 18.0029 135.044 18.0029C139.054 18.0029 141.991 20.9255 141.991 24.9495C141.991 28.9734 139.054 31.8961 135.044 31.8961C131.034 31.8961 128.097 28.9734 128.097 24.9495ZM137.805 24.9495C137.805 22.8807 136.574 21.6282 135.044 21.6282C133.514 21.6282 132.283 22.8807 132.283 24.9495C132.283 27.0183 133.514 28.2707 135.044 28.2707C136.574 28.2707 137.801 27.0183 137.801 24.9495H137.805Z",
       :fill fill}]
     [:path
      {:d
       "M73.4758 28.2742H72.342V31.6374H68.1654V18.2651H74.1318C77.5852 18.2651 79.7807 20.2141 79.7807 23.3099C79.7807 25.2397 78.9304 26.6914 77.4434 27.513L80.0464 31.6409H77.0903C76.6266 31.6409 76.17 31.5181 75.7605 31.2832C75.351 31.0484 75.0012 30.7088 74.7417 30.2941L73.4758 28.2742ZM73.8654 21.7392H72.342V24.8726H73.8654C75.0162 24.8726 75.5661 24.2809 75.5661 23.3064C75.5661 22.3318 75.0162 21.7392 73.8654 21.7392Z",
       :fill fill}]
     [:path
      {:d
       "M62.1925 29.2767H57.5138L56.6869 31.592H52.4667L57.415 19.3751C57.5438 19.0574 57.7555 18.7872 58.0244 18.5973C58.2932 18.4075 58.6074 18.3063 58.9287 18.3062H61.9253L67.3069 31.5911H63.0145L62.1925 29.2767ZM61.049 26.0499L59.8528 22.7094L58.6574 26.0499H61.049Z",
       :fill fill}]
     [:path
      {:d
       "M90.6227 29.2767H85.9448L85.1179 31.592H80.8976L85.846 19.3751C85.9746 19.0574 86.1864 18.787 86.4552 18.5972C86.724 18.4073 87.0384 18.3062 87.3596 18.3062H90.3562L95.7371 31.5911H91.4447L90.6227 29.2767ZM89.4799 26.0499L88.2837 22.7094L87.0875 26.0499H89.4799Z",
       :fill fill}]
     [:path
      {:d
       "M117.364 28.137V31.516H107.129V18.231H117.136V20.0944C117.136 20.2934 117.099 20.4904 117.029 20.6742C116.958 20.858 116.855 21.0251 116.724 21.1657C116.594 21.3064 116.439 21.4179 116.269 21.494C116.098 21.5701 115.916 21.6092 115.731 21.609H111.209V23.1657H116.415V26.3925H111.209V28.1405L117.364 28.137Z",
       :fill fill}]
     [:path
      {:d
       "M96.5591 18.3062H100.71V28.1187H105.036C105.363 28.1187 105.676 28.2586 105.907 28.5077C106.137 28.7569 106.267 29.0948 106.267 29.4471V31.592H96.5591V18.3062Z",
       :fill fill}]
     [:path
      {:d
       "M118.323 18.3062H122.474V28.1187H126.801C127.127 28.1187 127.441 28.2586 127.671 28.5077C127.902 28.7569 128.032 29.0948 128.032 29.4471V31.592H118.323V18.3062Z",
       :fill fill}]]))

(defn check [{:keys [width height]}]
  [:svg
   {:height (or height 9)
    :width (or width 16)
    :fill "none",
    :xmlns "http://www.w3.org/2000/svg",
    :view-box (str "0 0 16 9")}
   [:path
    {:d               "M10.4686 1.01919L4.23724 7.87612L1.19857 4.9698",
     :fill            "none"
     :stroke          "currentColor"
     :stroke-width    "0.870334"
     :stroke-linecap  "round"
     :stroke-linejoin "round"}]])

(defn double-check [_props]
  [:svg
   {:height "9",
    :width "16",
    :fill "none",
    :xmlns "http://www.w3.org/2000/svg",
    :view-box "0 0 16 9"}
   [:path
    {:d               "M10.4686 1.01919L4.23724 7.87612L1.19857 4.9698",
     :fill            "none"
     :stroke          "currentColor"
     :stroke-width    "0.870334"
     :stroke-linecap  "round"
     :stroke-linejoin "round"}]
   [:path
    {:d               "M14.7737 1.01852L8.54207 7.87581L6.28258 5.73576"
     :fill            "none"
     :stroke          "currentColor"
     :stroke-width    "0.870334"
     :stroke-linecap  "round"
     :stroke-linejoin "round"}]])

(defn broken-image
  []
  [:svg
   {:width 33,
    :height 32,
    :view-box "0 0 33 32",
    :fill "none",
    :xmlns "http://www.w3.org/2000/svg"}
   [:g
    [:path
     {:d
      "M28.5 24.2 8.3 4h17.534c.733 0 1.36.261 1.883.783a2.57 2.57 0 0 1 .783 1.884V24.2ZM7.167 28a2.568 2.568 0 0 1-1.883-.783 2.568 2.568 0 0 1-.784-1.884v-17.6l-1.2-1.2c-.244-.244-.366-.555-.366-.933s.122-.689.366-.933c.245-.245.556-.367.934-.367.377 0 .688.122.933.367l22.667 22.666c.244.245.366.556.366.934 0 .377-.122.689-.366.933-.245.244-.556.367-.934.367-.377 0-.689-.123-.933-.367l-1.2-1.2h-17.6ZM19.4 22.667l-2.8-2.8-1.1 1.466-2.466-3.3a.634.634 0 0 0-.534-.266c-.222 0-.4.089-.533.266L9.3 21.6c-.178.222-.2.456-.066.7.133.244.333.367.6.367H19.4Z",
      :fill "currentColor"}]]])

(defn arrow-left
  [{:keys [width height]}]
  [:svg
   {:width (or width 48)
    :height (or height 48)
    :view-box "0 0 48 48",
    :fill "none",
    :xmlns "http://www.w3.org/2000/svg"}
   [:path
    {:d
     "M21.75 38.6 8.55 25.4c-.2-.2-.342-.417-.426-.65A2.23 2.23 0 0 1 8 24c0-.267.041-.517.124-.75a1.76 1.76 0 0 1 .426-.65l13.2-13.2c.367-.367.825-.56 1.374-.577a1.866 1.866 0 0 1 1.426.576c.4.367.609.825.626 1.374A1.866 1.866 0 0 1 24.6 12.2L14.8 22h22.35c.567 0 1.042.192 1.426.574.383.384.574.86.574 1.426 0 .567-.191 1.042-.574 1.424-.384.384-.86.576-1.426.576H14.8l9.8 9.8c.367.367.559.834.576 1.4.016.567-.176 1.034-.576 1.4-.367.4-.833.6-1.4.6s-1.05-.2-1.45-.6Z",
     :fill "currentColor"}]])

(defn replay
  [{:keys [width height]}]
  [:svg
   {:width (or width 48)
    :height (or height 48)
    :view-box "0 0 48 48",
    :fill "none",
    :xmlns "http://www.w3.org/2000/svg"}
   [:path
    {:d
     "M24 44c-4.666 0-8.691-1.534-12.074-4.6C8.542 36.333 6.6 32.533 6.1 28c-.066-.534.092-1 .476-1.4.383-.4.858-.6 1.424-.6.534 0 1.009.19 1.426.574.416.384.658.859.724 1.426.467 3.433 2 6.292 4.6 8.576C17.35 38.858 20.434 40 24 40c3.9 0 7.208-1.36 9.924-4.076C36.642 33.208 38 29.9 38 26c0-3.9-1.358-7.21-4.076-9.926C31.208 13.358 27.9 12 24 12h-.3l1.75 1.75c.367.366.55.833.55 1.4 0 .566-.183 1.033-.55 1.4-.4.4-.883.6-1.45.6-.566 0-1.033-.2-1.4-.6l-5.2-5.15a1.75 1.75 0 0 1-.424-.65 2.197 2.197 0 0 1-.126-.75c0-.267.042-.517.126-.75.083-.234.224-.45.424-.65l5.2-5.2c.367-.367.834-.55 1.4-.55.567 0 1.05.183 1.45.55.367.4.55.883.55 1.45 0 .566-.183 1.033-.55 1.4L23.7 8h.3c2.5 0 4.842.475 7.026 1.426 2.183.949 4.083 2.232 5.7 3.848 1.616 1.617 2.9 3.517 3.85 5.7C41.526 21.158 42 23.5 42 26s-.474 4.84-1.424 7.024-2.234 4.084-3.85 5.7c-1.617 1.617-3.517 2.9-5.7 3.852C28.842 43.525 26.5 44 24 44Z",
     :fill "currentColor"}]])

(defn next-media
  [{:keys [width height]}]
  [:svg
   {:width (or width 38),
    :height (or height 38),
    :view-box "0 0 26 24",
    :fill "none",
    :xmlns "http://www.w3.org/2000/svg"}
   [:path
    {:d
     "M24 24c-.567 0-1.042-.192-1.425-.575C22.192 23.042 22 22.567 22 22V2c0-.567.192-1.042.575-1.425C22.958.192 23.433 0 24 0c.567 0 1.042.192 1.425.575C25.808.958 26 1.433 26 2v20c0 .567-.192 1.042-.575 1.425-.383.383-.858.575-1.425.575ZM3.1 21.95c-.667.467-1.35.5-2.05.1-.7-.4-1.05-1-1.05-1.8V3.75c0-.8.35-1.392 1.05-1.775.7-.383 1.383-.358 2.05.075l12.4 8.3c.6.4.9.95.9 1.65s-.3 1.25-.9 1.65l-12.4 8.3Z",
     :fill "currentColor"}]])

(defn skip-forward
  [{:keys [width height]}]
  [:svg
   {:width (or width 48)
    :height (or height 48)
    :view-box "0 0 48 48",
    :fill "none",
    :xmlns "http://www.w3.org/2000/svg"}
   [:path
    {:d
     "M35 36c-.567 0-1.041-.192-1.424-.576C33.192 35.041 33 34.567 33 34V14c0-.567.192-1.042.576-1.426.383-.383.857-.574 1.424-.574s1.041.191 1.424.574c.384.384.576.86.576 1.426v20c0 .567-.192 1.041-.576 1.424-.383.384-.857.576-1.424.576Zm-20.9-2.05c-.667.467-1.35.5-2.05.1-.7-.4-1.05-1-1.05-1.8v-16.5c0-.8.35-1.392 1.05-1.776.7-.383 1.383-.357 2.05.076l12.4 8.3c.6.4.9.95.9 1.65s-.3 1.25-.9 1.65l-12.4 8.3Z",
     :fill "currentColor"}]])

(defn pause
  [{:keys [width height]}]
  [:svg
   {:width (or width 48)
    :height (or height 48)
    :view-box "0 0 48 48",
    :fill "none",
    :xmlns "http://www.w3.org/2000/svg"}
   [:path
    {:d
     "M30 38c-1.1 0-2.041-.391-2.824-1.174C26.392 36.042 26 35.1 26 34V14c0-1.1.392-2.041 1.176-2.824C27.959 10.392 28.9 10 30 10h4c1.1 0 2.042.392 2.826 1.176C37.609 11.959 38 12.9 38 14v20c0 1.1-.391 2.042-1.174 2.826C36.042 37.609 35.1 38 34 38h-4Zm-16 0c-1.1 0-2.041-.391-2.824-1.174C10.392 36.042 10 35.1 10 34V14c0-1.1.392-2.041 1.176-2.824C11.959 10.392 12.9 10 14 10h4c1.1 0 2.042.392 2.826 1.176C21.609 11.959 22 12.9 22 14v20c0 1.1-.391 2.042-1.174 2.826C20.042 37.609 19.1 38 18 38h-4Z",
     :fill "currentColor"}]])
